var fn = Object.defineProperty, hn = Object.defineProperties;
var pn = Object.getOwnPropertyDescriptors;
var jt = Object.getOwnPropertySymbols;
var mn = Object.prototype.hasOwnProperty, yn = Object.prototype.propertyIsEnumerable;
var Zt = (n) => {
  throw TypeError(n);
};
var Rt = (n, e, t) => e in n ? fn(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, u = (n, e) => {
  for (var t in e || (e = {}))
    mn.call(e, t) && Rt(n, t, e[t]);
  if (jt)
    for (var t of jt(e))
      yn.call(e, t) && Rt(n, t, e[t]);
  return n;
}, y = (n, e) => hn(n, pn(e));
var Mt = (n, e, t) => e.has(n) || Zt("Cannot " + t);
var B = (n, e, t) => (Mt(n, e, "read from private field"), t ? t.call(n) : e.get(n)), ct = (n, e, t) => e.has(n) ? Zt("Cannot add the same private member more than once") : e instanceof WeakSet ? e.add(n) : e.set(n, t), ut = (n, e, t, s) => (Mt(n, e, "write to private field"), s ? s.call(n, t) : e.set(n, t), t);
var P = (n, e, t) => new Promise((s, r) => {
  var a = (c) => {
    try {
      o(t.next(c));
    } catch (d) {
      r(d);
    }
  }, i = (c) => {
    try {
      o(t.throw(c));
    } catch (d) {
      r(d);
    }
  }, o = (c) => c.done ? s(c.value) : Promise.resolve(c.value).then(a, i);
  o((t = t.apply(n, e)).next());
});
class Ae extends Error {
  constructor({ name: e, reason: t, status: s }) {
    super(), this.name = `[Codegen Error] ${e}`, this.message = t, this.status = s;
  }
}
var k;
(function(n) {
  n.assertEqual = (r) => r;
  function e(r) {
  }
  n.assertIs = e;
  function t(r) {
    throw new Error();
  }
  n.assertNever = t, n.arrayToEnum = (r) => {
    const a = {};
    for (const i of r)
      a[i] = i;
    return a;
  }, n.getValidEnumValues = (r) => {
    const a = n.objectKeys(r).filter((o) => typeof r[r[o]] != "number"), i = {};
    for (const o of a)
      i[o] = r[o];
    return n.objectValues(i);
  }, n.objectValues = (r) => n.objectKeys(r).map(function(a) {
    return r[a];
  }), n.objectKeys = typeof Object.keys == "function" ? (r) => Object.keys(r) : (r) => {
    const a = [];
    for (const i in r)
      Object.prototype.hasOwnProperty.call(r, i) && a.push(i);
    return a;
  }, n.find = (r, a) => {
    for (const i of r)
      if (a(i))
        return i;
  }, n.isInteger = typeof Number.isInteger == "function" ? (r) => Number.isInteger(r) : (r) => typeof r == "number" && isFinite(r) && Math.floor(r) === r;
  function s(r, a = " | ") {
    return r.map((i) => typeof i == "string" ? `'${i}'` : i).join(a);
  }
  n.joinValues = s, n.jsonStringifyReplacer = (r, a) => typeof a == "bigint" ? a.toString() : a;
})(k || (k = {}));
var pt;
(function(n) {
  n.mergeShapes = (e, t) => u(u({}, e), t);
})(pt || (pt = {}));
const p = k.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), ae = (n) => {
  switch (typeof n) {
    case "undefined":
      return p.undefined;
    case "string":
      return p.string;
    case "number":
      return isNaN(n) ? p.nan : p.number;
    case "boolean":
      return p.boolean;
    case "function":
      return p.function;
    case "bigint":
      return p.bigint;
    case "symbol":
      return p.symbol;
    case "object":
      return Array.isArray(n) ? p.array : n === null ? p.null : n.then && typeof n.then == "function" && n.catch && typeof n.catch == "function" ? p.promise : typeof Map != "undefined" && n instanceof Map ? p.map : typeof Set != "undefined" && n instanceof Set ? p.set : typeof Date != "undefined" && n instanceof Date ? p.date : p.object;
    default:
      return p.unknown;
  }
}, l = k.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]), gn = (n) => JSON.stringify(n, null, 2).replace(/"([^"]+)":/g, "$1:");
class U extends Error {
  get errors() {
    return this.issues;
  }
  constructor(e) {
    super(), this.issues = [], this.addIssue = (s) => {
      this.issues = [...this.issues, s];
    }, this.addIssues = (s = []) => {
      this.issues = [...this.issues, ...s];
    };
    const t = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, t) : this.__proto__ = t, this.name = "ZodError", this.issues = e;
  }
  format(e) {
    const t = e || function(a) {
      return a.message;
    }, s = { _errors: [] }, r = (a) => {
      for (const i of a.issues)
        if (i.code === "invalid_union")
          i.unionErrors.map(r);
        else if (i.code === "invalid_return_type")
          r(i.returnTypeError);
        else if (i.code === "invalid_arguments")
          r(i.argumentsError);
        else if (i.path.length === 0)
          s._errors.push(t(i));
        else {
          let o = s, c = 0;
          for (; c < i.path.length; ) {
            const d = i.path[c];
            c === i.path.length - 1 ? (o[d] = o[d] || { _errors: [] }, o[d]._errors.push(t(i))) : o[d] = o[d] || { _errors: [] }, o = o[d], c++;
          }
        }
    };
    return r(this), s;
  }
  static assert(e) {
    if (!(e instanceof U))
      throw new Error(`Not a ZodError: ${e}`);
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, k.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(e = (t) => t.message) {
    const t = {}, s = [];
    for (const r of this.issues)
      r.path.length > 0 ? (t[r.path[0]] = t[r.path[0]] || [], t[r.path[0]].push(e(r))) : s.push(e(r));
    return { formErrors: s, fieldErrors: t };
  }
  get formErrors() {
    return this.flatten();
  }
}
U.create = (n) => new U(n);
const ke = (n, e) => {
  let t;
  switch (n.code) {
    case l.invalid_type:
      n.received === p.undefined ? t = "Required" : t = `Expected ${n.expected}, received ${n.received}`;
      break;
    case l.invalid_literal:
      t = `Invalid literal value, expected ${JSON.stringify(n.expected, k.jsonStringifyReplacer)}`;
      break;
    case l.unrecognized_keys:
      t = `Unrecognized key(s) in object: ${k.joinValues(n.keys, ", ")}`;
      break;
    case l.invalid_union:
      t = "Invalid input";
      break;
    case l.invalid_union_discriminator:
      t = `Invalid discriminator value. Expected ${k.joinValues(n.options)}`;
      break;
    case l.invalid_enum_value:
      t = `Invalid enum value. Expected ${k.joinValues(n.options)}, received '${n.received}'`;
      break;
    case l.invalid_arguments:
      t = "Invalid function arguments";
      break;
    case l.invalid_return_type:
      t = "Invalid function return type";
      break;
    case l.invalid_date:
      t = "Invalid date";
      break;
    case l.invalid_string:
      typeof n.validation == "object" ? "includes" in n.validation ? (t = `Invalid input: must include "${n.validation.includes}"`, typeof n.validation.position == "number" && (t = `${t} at one or more positions greater than or equal to ${n.validation.position}`)) : "startsWith" in n.validation ? t = `Invalid input: must start with "${n.validation.startsWith}"` : "endsWith" in n.validation ? t = `Invalid input: must end with "${n.validation.endsWith}"` : k.assertNever(n.validation) : n.validation !== "regex" ? t = `Invalid ${n.validation}` : t = "Invalid";
      break;
    case l.too_small:
      n.type === "array" ? t = `Array must contain ${n.exact ? "exactly" : n.inclusive ? "at least" : "more than"} ${n.minimum} element(s)` : n.type === "string" ? t = `String must contain ${n.exact ? "exactly" : n.inclusive ? "at least" : "over"} ${n.minimum} character(s)` : n.type === "number" ? t = `Number must be ${n.exact ? "exactly equal to " : n.inclusive ? "greater than or equal to " : "greater than "}${n.minimum}` : n.type === "date" ? t = `Date must be ${n.exact ? "exactly equal to " : n.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(n.minimum))}` : t = "Invalid input";
      break;
    case l.too_big:
      n.type === "array" ? t = `Array must contain ${n.exact ? "exactly" : n.inclusive ? "at most" : "less than"} ${n.maximum} element(s)` : n.type === "string" ? t = `String must contain ${n.exact ? "exactly" : n.inclusive ? "at most" : "under"} ${n.maximum} character(s)` : n.type === "number" ? t = `Number must be ${n.exact ? "exactly" : n.inclusive ? "less than or equal to" : "less than"} ${n.maximum}` : n.type === "bigint" ? t = `BigInt must be ${n.exact ? "exactly" : n.inclusive ? "less than or equal to" : "less than"} ${n.maximum}` : n.type === "date" ? t = `Date must be ${n.exact ? "exactly" : n.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(n.maximum))}` : t = "Invalid input";
      break;
    case l.custom:
      t = "Invalid input";
      break;
    case l.invalid_intersection_types:
      t = "Intersection results could not be merged";
      break;
    case l.not_multiple_of:
      t = `Number must be a multiple of ${n.multipleOf}`;
      break;
    case l.not_finite:
      t = "Number must be finite";
      break;
    default:
      t = e.defaultError, k.assertNever(n);
  }
  return { message: t };
};
let qt = ke;
function vn(n) {
  qt = n;
}
function Qe() {
  return qt;
}
const et = (n) => {
  const { data: e, path: t, errorMaps: s, issueData: r } = n, a = [...t, ...r.path || []], i = y(u({}, r), {
    path: a
  });
  if (r.message !== void 0)
    return y(u({}, r), {
      path: a,
      message: r.message
    });
  let o = "";
  const c = s.filter((d) => !!d).slice().reverse();
  for (const d of c)
    o = d(i, { data: e, defaultError: o }).message;
  return y(u({}, r), {
    path: a,
    message: o
  });
}, _n = [];
function h(n, e) {
  const t = Qe(), s = et({
    issueData: e,
    data: n.data,
    path: n.path,
    errorMaps: [
      n.common.contextualErrorMap,
      // contextual error map is first priority
      n.schemaErrorMap,
      // then schema-bound map if available
      t,
      // then global override map
      t === ke ? void 0 : ke
      // then global default map
    ].filter((r) => !!r)
  });
  n.common.issues.push(s);
}
class R {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(e, t) {
    const s = [];
    for (const r of t) {
      if (r.status === "aborted")
        return v;
      r.status === "dirty" && e.dirty(), s.push(r.value);
    }
    return { status: e.value, value: s };
  }
  static mergeObjectAsync(e, t) {
    return P(this, null, function* () {
      const s = [];
      for (const r of t) {
        const a = yield r.key, i = yield r.value;
        s.push({
          key: a,
          value: i
        });
      }
      return R.mergeObjectSync(e, s);
    });
  }
  static mergeObjectSync(e, t) {
    const s = {};
    for (const r of t) {
      const { key: a, value: i } = r;
      if (a.status === "aborted" || i.status === "aborted")
        return v;
      a.status === "dirty" && e.dirty(), i.status === "dirty" && e.dirty(), a.value !== "__proto__" && (typeof i.value != "undefined" || r.alwaysSet) && (s[a.value] = i.value);
    }
    return { status: e.value, value: s };
  }
}
const v = Object.freeze({
  status: "aborted"
}), we = (n) => ({ status: "dirty", value: n }), $ = (n) => ({ status: "valid", value: n }), mt = (n) => n.status === "aborted", yt = (n) => n.status === "dirty", ye = (n) => n.status === "valid", Ze = (n) => typeof Promise != "undefined" && n instanceof Promise;
function tt(n, e, t, s) {
  if (typeof e == "function" ? n !== e || !0 : !e.has(n)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return e.get(n);
}
function Ht(n, e, t, s, r) {
  if (typeof e == "function" ? n !== e || !0 : !e.has(n)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return e.set(n, t), t;
}
var m;
(function(n) {
  n.errToObj = (e) => typeof e == "string" ? { message: e } : e || {}, n.toString = (e) => typeof e == "string" ? e : e == null ? void 0 : e.message;
})(m || (m = {}));
var Ce, Ie;
class Q {
  constructor(e, t, s, r) {
    this._cachedPath = [], this.parent = e, this.data = t, this._path = s, this._key = r;
  }
  get path() {
    return this._cachedPath.length || (this._key instanceof Array ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const $t = (n, e) => {
  if (ye(e))
    return { success: !0, data: e.value };
  if (!n.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const t = new U(n.common.issues);
      return this._error = t, this._error;
    }
  };
};
function w(n) {
  if (!n)
    return {};
  const { errorMap: e, invalid_type_error: t, required_error: s, description: r } = n;
  if (e && (t || s))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return e ? { errorMap: e, description: r } : { errorMap: (i, o) => {
    var c, d;
    const { message: f } = n;
    return i.code === "invalid_enum_value" ? { message: f != null ? f : o.defaultError } : typeof o.data == "undefined" ? { message: (c = f != null ? f : s) !== null && c !== void 0 ? c : o.defaultError } : i.code !== "invalid_type" ? { message: o.defaultError } : { message: (d = f != null ? f : t) !== null && d !== void 0 ? d : o.defaultError };
  }, description: r };
}
class x {
  get description() {
    return this._def.description;
  }
  _getType(e) {
    return ae(e.data);
  }
  _getOrReturnCtx(e, t) {
    return t || {
      common: e.parent.common,
      data: e.data,
      parsedType: ae(e.data),
      schemaErrorMap: this._def.errorMap,
      path: e.path,
      parent: e.parent
    };
  }
  _processInputParams(e) {
    return {
      status: new R(),
      ctx: {
        common: e.parent.common,
        data: e.data,
        parsedType: ae(e.data),
        schemaErrorMap: this._def.errorMap,
        path: e.path,
        parent: e.parent
      }
    };
  }
  _parseSync(e) {
    const t = this._parse(e);
    if (Ze(t))
      throw new Error("Synchronous parse encountered promise.");
    return t;
  }
  _parseAsync(e) {
    const t = this._parse(e);
    return Promise.resolve(t);
  }
  parse(e, t) {
    const s = this.safeParse(e, t);
    if (s.success)
      return s.data;
    throw s.error;
  }
  safeParse(e, t) {
    var s;
    const r = {
      common: {
        issues: [],
        async: (s = t == null ? void 0 : t.async) !== null && s !== void 0 ? s : !1,
        contextualErrorMap: t == null ? void 0 : t.errorMap
      },
      path: (t == null ? void 0 : t.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: ae(e)
    }, a = this._parseSync({ data: e, path: r.path, parent: r });
    return $t(r, a);
  }
  "~validate"(e) {
    var t, s;
    const r = {
      common: {
        issues: [],
        async: !!this["~standard"].async
      },
      path: [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: ae(e)
    };
    if (!this["~standard"].async)
      try {
        const a = this._parseSync({ data: e, path: [], parent: r });
        return ye(a) ? {
          value: a.value
        } : {
          issues: r.common.issues
        };
      } catch (a) {
        !((s = (t = a == null ? void 0 : a.message) === null || t === void 0 ? void 0 : t.toLowerCase()) === null || s === void 0) && s.includes("encountered") && (this["~standard"].async = !0), r.common = {
          issues: [],
          async: !0
        };
      }
    return this._parseAsync({ data: e, path: [], parent: r }).then((a) => ye(a) ? {
      value: a.value
    } : {
      issues: r.common.issues
    });
  }
  parseAsync(e, t) {
    return P(this, null, function* () {
      const s = yield this.safeParseAsync(e, t);
      if (s.success)
        return s.data;
      throw s.error;
    });
  }
  safeParseAsync(e, t) {
    return P(this, null, function* () {
      const s = {
        common: {
          issues: [],
          contextualErrorMap: t == null ? void 0 : t.errorMap,
          async: !0
        },
        path: (t == null ? void 0 : t.path) || [],
        schemaErrorMap: this._def.errorMap,
        parent: null,
        data: e,
        parsedType: ae(e)
      }, r = this._parse({ data: e, path: s.path, parent: s }), a = yield Ze(r) ? r : Promise.resolve(r);
      return $t(s, a);
    });
  }
  refine(e, t) {
    const s = (r) => typeof t == "string" || typeof t == "undefined" ? { message: t } : typeof t == "function" ? t(r) : t;
    return this._refinement((r, a) => {
      const i = e(r), o = () => a.addIssue(u({
        code: l.custom
      }, s(r)));
      return typeof Promise != "undefined" && i instanceof Promise ? i.then((c) => c ? !0 : (o(), !1)) : i ? !0 : (o(), !1);
    });
  }
  refinement(e, t) {
    return this._refinement((s, r) => e(s) ? !0 : (r.addIssue(typeof t == "function" ? t(s, r) : t), !1));
  }
  _refinement(e) {
    return new J({
      schema: this,
      typeName: g.ZodEffects,
      effect: { type: "refinement", refinement: e }
    });
  }
  superRefine(e) {
    return this._refinement(e);
  }
  constructor(e) {
    this.spa = this.safeParseAsync, this._def = e, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this), this["~standard"] = {
      version: 1,
      vendor: "zod",
      validate: (t) => this["~validate"](t)
    };
  }
  optional() {
    return Y.create(this, this._def);
  }
  nullable() {
    return fe.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return H.create(this);
  }
  promise() {
    return Se.create(this, this._def);
  }
  or(e) {
    return Fe.create([this, e], this._def);
  }
  and(e) {
    return Le.create(this, e, this._def);
  }
  transform(e) {
    return new J(y(u({}, w(this._def)), {
      schema: this,
      typeName: g.ZodEffects,
      effect: { type: "transform", transform: e }
    }));
  }
  default(e) {
    const t = typeof e == "function" ? e : () => e;
    return new We(y(u({}, w(this._def)), {
      innerType: this,
      defaultValue: t,
      typeName: g.ZodDefault
    }));
  }
  brand() {
    return new At(u({
      typeName: g.ZodBranded,
      type: this
    }, w(this._def)));
  }
  catch(e) {
    const t = typeof e == "function" ? e : () => e;
    return new Be(y(u({}, w(this._def)), {
      innerType: this,
      catchValue: t,
      typeName: g.ZodCatch
    }));
  }
  describe(e) {
    const t = this.constructor;
    return new t(y(u({}, this._def), {
      description: e
    }));
  }
  pipe(e) {
    return Je.create(this, e);
  }
  readonly() {
    return qe.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const bn = /^c[^\s-]{8,}$/i, wn = /^[0-9a-z]+$/, xn = /^[0-9A-HJKMNP-TV-Z]{26}$/i, kn = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, Tn = /^[a-z0-9_-]{21}$/i, Sn = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/, En = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, An = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, On = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let dt;
const Cn = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, In = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/, Nn = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/, jn = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, Rn = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, Zn = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/, Jt = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", Mn = new RegExp(`^${Jt}$`);
function Gt(n) {
  let e = "([01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d";
  return n.precision ? e = `${e}\\.\\d{${n.precision}}` : n.precision == null && (e = `${e}(\\.\\d+)?`), e;
}
function $n(n) {
  return new RegExp(`^${Gt(n)}$`);
}
function Kt(n) {
  let e = `${Jt}T${Gt(n)}`;
  const t = [];
  return t.push(n.local ? "Z?" : "Z"), n.offset && t.push("([+-]\\d{2}:?\\d{2})"), e = `${e}(${t.join("|")})`, new RegExp(`^${e}$`);
}
function Pn(n, e) {
  return !!((e === "v4" || !e) && Cn.test(n) || (e === "v6" || !e) && Nn.test(n));
}
function Fn(n, e) {
  if (!Sn.test(n))
    return !1;
  try {
    const [t] = n.split("."), s = t.replace(/-/g, "+").replace(/_/g, "/").padEnd(t.length + (4 - t.length % 4) % 4, "="), r = JSON.parse(atob(s));
    return !(typeof r != "object" || r === null || !r.typ || !r.alg || e && r.alg !== e);
  } catch (t) {
    return !1;
  }
}
function Ln(n, e) {
  return !!((e === "v4" || !e) && In.test(n) || (e === "v6" || !e) && jn.test(n));
}
class q extends x {
  _parse(e) {
    if (this._def.coerce && (e.data = String(e.data)), this._getType(e) !== p.string) {
      const a = this._getOrReturnCtx(e);
      return h(a, {
        code: l.invalid_type,
        expected: p.string,
        received: a.parsedType
      }), v;
    }
    const s = new R();
    let r;
    for (const a of this._def.checks)
      if (a.kind === "min")
        e.data.length < a.value && (r = this._getOrReturnCtx(e, r), h(r, {
          code: l.too_small,
          minimum: a.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: a.message
        }), s.dirty());
      else if (a.kind === "max")
        e.data.length > a.value && (r = this._getOrReturnCtx(e, r), h(r, {
          code: l.too_big,
          maximum: a.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: a.message
        }), s.dirty());
      else if (a.kind === "length") {
        const i = e.data.length > a.value, o = e.data.length < a.value;
        (i || o) && (r = this._getOrReturnCtx(e, r), i ? h(r, {
          code: l.too_big,
          maximum: a.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: a.message
        }) : o && h(r, {
          code: l.too_small,
          minimum: a.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: a.message
        }), s.dirty());
      } else if (a.kind === "email")
        An.test(e.data) || (r = this._getOrReturnCtx(e, r), h(r, {
          validation: "email",
          code: l.invalid_string,
          message: a.message
        }), s.dirty());
      else if (a.kind === "emoji")
        dt || (dt = new RegExp(On, "u")), dt.test(e.data) || (r = this._getOrReturnCtx(e, r), h(r, {
          validation: "emoji",
          code: l.invalid_string,
          message: a.message
        }), s.dirty());
      else if (a.kind === "uuid")
        kn.test(e.data) || (r = this._getOrReturnCtx(e, r), h(r, {
          validation: "uuid",
          code: l.invalid_string,
          message: a.message
        }), s.dirty());
      else if (a.kind === "nanoid")
        Tn.test(e.data) || (r = this._getOrReturnCtx(e, r), h(r, {
          validation: "nanoid",
          code: l.invalid_string,
          message: a.message
        }), s.dirty());
      else if (a.kind === "cuid")
        bn.test(e.data) || (r = this._getOrReturnCtx(e, r), h(r, {
          validation: "cuid",
          code: l.invalid_string,
          message: a.message
        }), s.dirty());
      else if (a.kind === "cuid2")
        wn.test(e.data) || (r = this._getOrReturnCtx(e, r), h(r, {
          validation: "cuid2",
          code: l.invalid_string,
          message: a.message
        }), s.dirty());
      else if (a.kind === "ulid")
        xn.test(e.data) || (r = this._getOrReturnCtx(e, r), h(r, {
          validation: "ulid",
          code: l.invalid_string,
          message: a.message
        }), s.dirty());
      else if (a.kind === "url")
        try {
          new URL(e.data);
        } catch (i) {
          r = this._getOrReturnCtx(e, r), h(r, {
            validation: "url",
            code: l.invalid_string,
            message: a.message
          }), s.dirty();
        }
      else a.kind === "regex" ? (a.regex.lastIndex = 0, a.regex.test(e.data) || (r = this._getOrReturnCtx(e, r), h(r, {
        validation: "regex",
        code: l.invalid_string,
        message: a.message
      }), s.dirty())) : a.kind === "trim" ? e.data = e.data.trim() : a.kind === "includes" ? e.data.includes(a.value, a.position) || (r = this._getOrReturnCtx(e, r), h(r, {
        code: l.invalid_string,
        validation: { includes: a.value, position: a.position },
        message: a.message
      }), s.dirty()) : a.kind === "toLowerCase" ? e.data = e.data.toLowerCase() : a.kind === "toUpperCase" ? e.data = e.data.toUpperCase() : a.kind === "startsWith" ? e.data.startsWith(a.value) || (r = this._getOrReturnCtx(e, r), h(r, {
        code: l.invalid_string,
        validation: { startsWith: a.value },
        message: a.message
      }), s.dirty()) : a.kind === "endsWith" ? e.data.endsWith(a.value) || (r = this._getOrReturnCtx(e, r), h(r, {
        code: l.invalid_string,
        validation: { endsWith: a.value },
        message: a.message
      }), s.dirty()) : a.kind === "datetime" ? Kt(a).test(e.data) || (r = this._getOrReturnCtx(e, r), h(r, {
        code: l.invalid_string,
        validation: "datetime",
        message: a.message
      }), s.dirty()) : a.kind === "date" ? Mn.test(e.data) || (r = this._getOrReturnCtx(e, r), h(r, {
        code: l.invalid_string,
        validation: "date",
        message: a.message
      }), s.dirty()) : a.kind === "time" ? $n(a).test(e.data) || (r = this._getOrReturnCtx(e, r), h(r, {
        code: l.invalid_string,
        validation: "time",
        message: a.message
      }), s.dirty()) : a.kind === "duration" ? En.test(e.data) || (r = this._getOrReturnCtx(e, r), h(r, {
        validation: "duration",
        code: l.invalid_string,
        message: a.message
      }), s.dirty()) : a.kind === "ip" ? Pn(e.data, a.version) || (r = this._getOrReturnCtx(e, r), h(r, {
        validation: "ip",
        code: l.invalid_string,
        message: a.message
      }), s.dirty()) : a.kind === "jwt" ? Fn(e.data, a.alg) || (r = this._getOrReturnCtx(e, r), h(r, {
        validation: "jwt",
        code: l.invalid_string,
        message: a.message
      }), s.dirty()) : a.kind === "cidr" ? Ln(e.data, a.version) || (r = this._getOrReturnCtx(e, r), h(r, {
        validation: "cidr",
        code: l.invalid_string,
        message: a.message
      }), s.dirty()) : a.kind === "base64" ? Rn.test(e.data) || (r = this._getOrReturnCtx(e, r), h(r, {
        validation: "base64",
        code: l.invalid_string,
        message: a.message
      }), s.dirty()) : a.kind === "base64url" ? Zn.test(e.data) || (r = this._getOrReturnCtx(e, r), h(r, {
        validation: "base64url",
        code: l.invalid_string,
        message: a.message
      }), s.dirty()) : k.assertNever(a);
    return { status: s.value, value: e.data };
  }
  _regex(e, t, s) {
    return this.refinement((r) => e.test(r), u({
      validation: t,
      code: l.invalid_string
    }, m.errToObj(s)));
  }
  _addCheck(e) {
    return new q(y(u({}, this._def), {
      checks: [...this._def.checks, e]
    }));
  }
  email(e) {
    return this._addCheck(u({ kind: "email" }, m.errToObj(e)));
  }
  url(e) {
    return this._addCheck(u({ kind: "url" }, m.errToObj(e)));
  }
  emoji(e) {
    return this._addCheck(u({ kind: "emoji" }, m.errToObj(e)));
  }
  uuid(e) {
    return this._addCheck(u({ kind: "uuid" }, m.errToObj(e)));
  }
  nanoid(e) {
    return this._addCheck(u({ kind: "nanoid" }, m.errToObj(e)));
  }
  cuid(e) {
    return this._addCheck(u({ kind: "cuid" }, m.errToObj(e)));
  }
  cuid2(e) {
    return this._addCheck(u({ kind: "cuid2" }, m.errToObj(e)));
  }
  ulid(e) {
    return this._addCheck(u({ kind: "ulid" }, m.errToObj(e)));
  }
  base64(e) {
    return this._addCheck(u({ kind: "base64" }, m.errToObj(e)));
  }
  base64url(e) {
    return this._addCheck(u({
      kind: "base64url"
    }, m.errToObj(e)));
  }
  jwt(e) {
    return this._addCheck(u({ kind: "jwt" }, m.errToObj(e)));
  }
  ip(e) {
    return this._addCheck(u({ kind: "ip" }, m.errToObj(e)));
  }
  cidr(e) {
    return this._addCheck(u({ kind: "cidr" }, m.errToObj(e)));
  }
  datetime(e) {
    var t, s;
    return typeof e == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      local: !1,
      message: e
    }) : this._addCheck(u({
      kind: "datetime",
      precision: typeof (e == null ? void 0 : e.precision) == "undefined" ? null : e == null ? void 0 : e.precision,
      offset: (t = e == null ? void 0 : e.offset) !== null && t !== void 0 ? t : !1,
      local: (s = e == null ? void 0 : e.local) !== null && s !== void 0 ? s : !1
    }, m.errToObj(e == null ? void 0 : e.message)));
  }
  date(e) {
    return this._addCheck({ kind: "date", message: e });
  }
  time(e) {
    return typeof e == "string" ? this._addCheck({
      kind: "time",
      precision: null,
      message: e
    }) : this._addCheck(u({
      kind: "time",
      precision: typeof (e == null ? void 0 : e.precision) == "undefined" ? null : e == null ? void 0 : e.precision
    }, m.errToObj(e == null ? void 0 : e.message)));
  }
  duration(e) {
    return this._addCheck(u({ kind: "duration" }, m.errToObj(e)));
  }
  regex(e, t) {
    return this._addCheck(u({
      kind: "regex",
      regex: e
    }, m.errToObj(t)));
  }
  includes(e, t) {
    return this._addCheck(u({
      kind: "includes",
      value: e,
      position: t == null ? void 0 : t.position
    }, m.errToObj(t == null ? void 0 : t.message)));
  }
  startsWith(e, t) {
    return this._addCheck(u({
      kind: "startsWith",
      value: e
    }, m.errToObj(t)));
  }
  endsWith(e, t) {
    return this._addCheck(u({
      kind: "endsWith",
      value: e
    }, m.errToObj(t)));
  }
  min(e, t) {
    return this._addCheck(u({
      kind: "min",
      value: e
    }, m.errToObj(t)));
  }
  max(e, t) {
    return this._addCheck(u({
      kind: "max",
      value: e
    }, m.errToObj(t)));
  }
  length(e, t) {
    return this._addCheck(u({
      kind: "length",
      value: e
    }, m.errToObj(t)));
  }
  /**
   * Equivalent to `.min(1)`
   */
  nonempty(e) {
    return this.min(1, m.errToObj(e));
  }
  trim() {
    return new q(y(u({}, this._def), {
      checks: [...this._def.checks, { kind: "trim" }]
    }));
  }
  toLowerCase() {
    return new q(y(u({}, this._def), {
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    }));
  }
  toUpperCase() {
    return new q(y(u({}, this._def), {
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    }));
  }
  get isDatetime() {
    return !!this._def.checks.find((e) => e.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((e) => e.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((e) => e.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((e) => e.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((e) => e.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((e) => e.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((e) => e.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((e) => e.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((e) => e.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((e) => e.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((e) => e.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((e) => e.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((e) => e.kind === "ip");
  }
  get isCIDR() {
    return !!this._def.checks.find((e) => e.kind === "cidr");
  }
  get isBase64() {
    return !!this._def.checks.find((e) => e.kind === "base64");
  }
  get isBase64url() {
    return !!this._def.checks.find((e) => e.kind === "base64url");
  }
  get minLength() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "min" && (e === null || t.value > e) && (e = t.value);
    return e;
  }
  get maxLength() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "max" && (e === null || t.value < e) && (e = t.value);
    return e;
  }
}
q.create = (n) => {
  var e;
  return new q(u({
    checks: [],
    typeName: g.ZodString,
    coerce: (e = n == null ? void 0 : n.coerce) !== null && e !== void 0 ? e : !1
  }, w(n)));
};
function Dn(n, e) {
  const t = (n.toString().split(".")[1] || "").length, s = (e.toString().split(".")[1] || "").length, r = t > s ? t : s, a = parseInt(n.toFixed(r).replace(".", "")), i = parseInt(e.toFixed(r).replace(".", ""));
  return a % i / Math.pow(10, r);
}
class ue extends x {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(e) {
    if (this._def.coerce && (e.data = Number(e.data)), this._getType(e) !== p.number) {
      const a = this._getOrReturnCtx(e);
      return h(a, {
        code: l.invalid_type,
        expected: p.number,
        received: a.parsedType
      }), v;
    }
    let s;
    const r = new R();
    for (const a of this._def.checks)
      a.kind === "int" ? k.isInteger(e.data) || (s = this._getOrReturnCtx(e, s), h(s, {
        code: l.invalid_type,
        expected: "integer",
        received: "float",
        message: a.message
      }), r.dirty()) : a.kind === "min" ? (a.inclusive ? e.data < a.value : e.data <= a.value) && (s = this._getOrReturnCtx(e, s), h(s, {
        code: l.too_small,
        minimum: a.value,
        type: "number",
        inclusive: a.inclusive,
        exact: !1,
        message: a.message
      }), r.dirty()) : a.kind === "max" ? (a.inclusive ? e.data > a.value : e.data >= a.value) && (s = this._getOrReturnCtx(e, s), h(s, {
        code: l.too_big,
        maximum: a.value,
        type: "number",
        inclusive: a.inclusive,
        exact: !1,
        message: a.message
      }), r.dirty()) : a.kind === "multipleOf" ? Dn(e.data, a.value) !== 0 && (s = this._getOrReturnCtx(e, s), h(s, {
        code: l.not_multiple_of,
        multipleOf: a.value,
        message: a.message
      }), r.dirty()) : a.kind === "finite" ? Number.isFinite(e.data) || (s = this._getOrReturnCtx(e, s), h(s, {
        code: l.not_finite,
        message: a.message
      }), r.dirty()) : k.assertNever(a);
    return { status: r.value, value: e.data };
  }
  gte(e, t) {
    return this.setLimit("min", e, !0, m.toString(t));
  }
  gt(e, t) {
    return this.setLimit("min", e, !1, m.toString(t));
  }
  lte(e, t) {
    return this.setLimit("max", e, !0, m.toString(t));
  }
  lt(e, t) {
    return this.setLimit("max", e, !1, m.toString(t));
  }
  setLimit(e, t, s, r) {
    return new ue(y(u({}, this._def), {
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: t,
          inclusive: s,
          message: m.toString(r)
        }
      ]
    }));
  }
  _addCheck(e) {
    return new ue(y(u({}, this._def), {
      checks: [...this._def.checks, e]
    }));
  }
  int(e) {
    return this._addCheck({
      kind: "int",
      message: m.toString(e)
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: m.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: m.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: m.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: m.toString(e)
    });
  }
  multipleOf(e, t) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: m.toString(t)
    });
  }
  finite(e) {
    return this._addCheck({
      kind: "finite",
      message: m.toString(e)
    });
  }
  safe(e) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: m.toString(e)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: m.toString(e)
    });
  }
  get minValue() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "min" && (e === null || t.value > e) && (e = t.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "max" && (e === null || t.value < e) && (e = t.value);
    return e;
  }
  get isInt() {
    return !!this._def.checks.find((e) => e.kind === "int" || e.kind === "multipleOf" && k.isInteger(e.value));
  }
  get isFinite() {
    let e = null, t = null;
    for (const s of this._def.checks) {
      if (s.kind === "finite" || s.kind === "int" || s.kind === "multipleOf")
        return !0;
      s.kind === "min" ? (t === null || s.value > t) && (t = s.value) : s.kind === "max" && (e === null || s.value < e) && (e = s.value);
    }
    return Number.isFinite(t) && Number.isFinite(e);
  }
}
ue.create = (n) => new ue(u({
  checks: [],
  typeName: g.ZodNumber,
  coerce: (n == null ? void 0 : n.coerce) || !1
}, w(n)));
class de extends x {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(e) {
    if (this._def.coerce)
      try {
        e.data = BigInt(e.data);
      } catch (a) {
        return this._getInvalidInput(e);
      }
    if (this._getType(e) !== p.bigint)
      return this._getInvalidInput(e);
    let s;
    const r = new R();
    for (const a of this._def.checks)
      a.kind === "min" ? (a.inclusive ? e.data < a.value : e.data <= a.value) && (s = this._getOrReturnCtx(e, s), h(s, {
        code: l.too_small,
        type: "bigint",
        minimum: a.value,
        inclusive: a.inclusive,
        message: a.message
      }), r.dirty()) : a.kind === "max" ? (a.inclusive ? e.data > a.value : e.data >= a.value) && (s = this._getOrReturnCtx(e, s), h(s, {
        code: l.too_big,
        type: "bigint",
        maximum: a.value,
        inclusive: a.inclusive,
        message: a.message
      }), r.dirty()) : a.kind === "multipleOf" ? e.data % a.value !== BigInt(0) && (s = this._getOrReturnCtx(e, s), h(s, {
        code: l.not_multiple_of,
        multipleOf: a.value,
        message: a.message
      }), r.dirty()) : k.assertNever(a);
    return { status: r.value, value: e.data };
  }
  _getInvalidInput(e) {
    const t = this._getOrReturnCtx(e);
    return h(t, {
      code: l.invalid_type,
      expected: p.bigint,
      received: t.parsedType
    }), v;
  }
  gte(e, t) {
    return this.setLimit("min", e, !0, m.toString(t));
  }
  gt(e, t) {
    return this.setLimit("min", e, !1, m.toString(t));
  }
  lte(e, t) {
    return this.setLimit("max", e, !0, m.toString(t));
  }
  lt(e, t) {
    return this.setLimit("max", e, !1, m.toString(t));
  }
  setLimit(e, t, s, r) {
    return new de(y(u({}, this._def), {
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: t,
          inclusive: s,
          message: m.toString(r)
        }
      ]
    }));
  }
  _addCheck(e) {
    return new de(y(u({}, this._def), {
      checks: [...this._def.checks, e]
    }));
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: m.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: m.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: m.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: m.toString(e)
    });
  }
  multipleOf(e, t) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: m.toString(t)
    });
  }
  get minValue() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "min" && (e === null || t.value > e) && (e = t.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "max" && (e === null || t.value < e) && (e = t.value);
    return e;
  }
}
de.create = (n) => {
  var e;
  return new de(u({
    checks: [],
    typeName: g.ZodBigInt,
    coerce: (e = n == null ? void 0 : n.coerce) !== null && e !== void 0 ? e : !1
  }, w(n)));
};
class Me extends x {
  _parse(e) {
    if (this._def.coerce && (e.data = !!e.data), this._getType(e) !== p.boolean) {
      const s = this._getOrReturnCtx(e);
      return h(s, {
        code: l.invalid_type,
        expected: p.boolean,
        received: s.parsedType
      }), v;
    }
    return $(e.data);
  }
}
Me.create = (n) => new Me(u({
  typeName: g.ZodBoolean,
  coerce: (n == null ? void 0 : n.coerce) || !1
}, w(n)));
class ge extends x {
  _parse(e) {
    if (this._def.coerce && (e.data = new Date(e.data)), this._getType(e) !== p.date) {
      const a = this._getOrReturnCtx(e);
      return h(a, {
        code: l.invalid_type,
        expected: p.date,
        received: a.parsedType
      }), v;
    }
    if (isNaN(e.data.getTime())) {
      const a = this._getOrReturnCtx(e);
      return h(a, {
        code: l.invalid_date
      }), v;
    }
    const s = new R();
    let r;
    for (const a of this._def.checks)
      a.kind === "min" ? e.data.getTime() < a.value && (r = this._getOrReturnCtx(e, r), h(r, {
        code: l.too_small,
        message: a.message,
        inclusive: !0,
        exact: !1,
        minimum: a.value,
        type: "date"
      }), s.dirty()) : a.kind === "max" ? e.data.getTime() > a.value && (r = this._getOrReturnCtx(e, r), h(r, {
        code: l.too_big,
        message: a.message,
        inclusive: !0,
        exact: !1,
        maximum: a.value,
        type: "date"
      }), s.dirty()) : k.assertNever(a);
    return {
      status: s.value,
      value: new Date(e.data.getTime())
    };
  }
  _addCheck(e) {
    return new ge(y(u({}, this._def), {
      checks: [...this._def.checks, e]
    }));
  }
  min(e, t) {
    return this._addCheck({
      kind: "min",
      value: e.getTime(),
      message: m.toString(t)
    });
  }
  max(e, t) {
    return this._addCheck({
      kind: "max",
      value: e.getTime(),
      message: m.toString(t)
    });
  }
  get minDate() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "min" && (e === null || t.value > e) && (e = t.value);
    return e != null ? new Date(e) : null;
  }
  get maxDate() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "max" && (e === null || t.value < e) && (e = t.value);
    return e != null ? new Date(e) : null;
  }
}
ge.create = (n) => new ge(u({
  checks: [],
  coerce: (n == null ? void 0 : n.coerce) || !1,
  typeName: g.ZodDate
}, w(n)));
class nt extends x {
  _parse(e) {
    if (this._getType(e) !== p.symbol) {
      const s = this._getOrReturnCtx(e);
      return h(s, {
        code: l.invalid_type,
        expected: p.symbol,
        received: s.parsedType
      }), v;
    }
    return $(e.data);
  }
}
nt.create = (n) => new nt(u({
  typeName: g.ZodSymbol
}, w(n)));
class $e extends x {
  _parse(e) {
    if (this._getType(e) !== p.undefined) {
      const s = this._getOrReturnCtx(e);
      return h(s, {
        code: l.invalid_type,
        expected: p.undefined,
        received: s.parsedType
      }), v;
    }
    return $(e.data);
  }
}
$e.create = (n) => new $e(u({
  typeName: g.ZodUndefined
}, w(n)));
class Pe extends x {
  _parse(e) {
    if (this._getType(e) !== p.null) {
      const s = this._getOrReturnCtx(e);
      return h(s, {
        code: l.invalid_type,
        expected: p.null,
        received: s.parsedType
      }), v;
    }
    return $(e.data);
  }
}
Pe.create = (n) => new Pe(u({
  typeName: g.ZodNull
}, w(n)));
class Te extends x {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(e) {
    return $(e.data);
  }
}
Te.create = (n) => new Te(u({
  typeName: g.ZodAny
}, w(n)));
class me extends x {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(e) {
    return $(e.data);
  }
}
me.create = (n) => new me(u({
  typeName: g.ZodUnknown
}, w(n)));
class ie extends x {
  _parse(e) {
    const t = this._getOrReturnCtx(e);
    return h(t, {
      code: l.invalid_type,
      expected: p.never,
      received: t.parsedType
    }), v;
  }
}
ie.create = (n) => new ie(u({
  typeName: g.ZodNever
}, w(n)));
class st extends x {
  _parse(e) {
    if (this._getType(e) !== p.undefined) {
      const s = this._getOrReturnCtx(e);
      return h(s, {
        code: l.invalid_type,
        expected: p.void,
        received: s.parsedType
      }), v;
    }
    return $(e.data);
  }
}
st.create = (n) => new st(u({
  typeName: g.ZodVoid
}, w(n)));
class H extends x {
  _parse(e) {
    const { ctx: t, status: s } = this._processInputParams(e), r = this._def;
    if (t.parsedType !== p.array)
      return h(t, {
        code: l.invalid_type,
        expected: p.array,
        received: t.parsedType
      }), v;
    if (r.exactLength !== null) {
      const i = t.data.length > r.exactLength.value, o = t.data.length < r.exactLength.value;
      (i || o) && (h(t, {
        code: i ? l.too_big : l.too_small,
        minimum: o ? r.exactLength.value : void 0,
        maximum: i ? r.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: r.exactLength.message
      }), s.dirty());
    }
    if (r.minLength !== null && t.data.length < r.minLength.value && (h(t, {
      code: l.too_small,
      minimum: r.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: r.minLength.message
    }), s.dirty()), r.maxLength !== null && t.data.length > r.maxLength.value && (h(t, {
      code: l.too_big,
      maximum: r.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: r.maxLength.message
    }), s.dirty()), t.common.async)
      return Promise.all([...t.data].map((i, o) => r.type._parseAsync(new Q(t, i, t.path, o)))).then((i) => R.mergeArray(s, i));
    const a = [...t.data].map((i, o) => r.type._parseSync(new Q(t, i, t.path, o)));
    return R.mergeArray(s, a);
  }
  get element() {
    return this._def.type;
  }
  min(e, t) {
    return new H(y(u({}, this._def), {
      minLength: { value: e, message: m.toString(t) }
    }));
  }
  max(e, t) {
    return new H(y(u({}, this._def), {
      maxLength: { value: e, message: m.toString(t) }
    }));
  }
  length(e, t) {
    return new H(y(u({}, this._def), {
      exactLength: { value: e, message: m.toString(t) }
    }));
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
H.create = (n, e) => new H(u({
  type: n,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: g.ZodArray
}, w(e)));
function be(n) {
  if (n instanceof S) {
    const e = {};
    for (const t in n.shape) {
      const s = n.shape[t];
      e[t] = Y.create(be(s));
    }
    return new S(y(u({}, n._def), {
      shape: () => e
    }));
  } else return n instanceof H ? new H(y(u({}, n._def), {
    type: be(n.element)
  })) : n instanceof Y ? Y.create(be(n.unwrap())) : n instanceof fe ? fe.create(be(n.unwrap())) : n instanceof ee ? ee.create(n.items.map((e) => be(e))) : n;
}
class S extends x {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const e = this._def.shape(), t = k.objectKeys(e);
    return this._cached = { shape: e, keys: t };
  }
  _parse(e) {
    if (this._getType(e) !== p.object) {
      const d = this._getOrReturnCtx(e);
      return h(d, {
        code: l.invalid_type,
        expected: p.object,
        received: d.parsedType
      }), v;
    }
    const { status: s, ctx: r } = this._processInputParams(e), { shape: a, keys: i } = this._getCached(), o = [];
    if (!(this._def.catchall instanceof ie && this._def.unknownKeys === "strip"))
      for (const d in r.data)
        i.includes(d) || o.push(d);
    const c = [];
    for (const d of i) {
      const f = a[d], _ = r.data[d];
      c.push({
        key: { status: "valid", value: d },
        value: f._parse(new Q(r, _, r.path, d)),
        alwaysSet: d in r.data
      });
    }
    if (this._def.catchall instanceof ie) {
      const d = this._def.unknownKeys;
      if (d === "passthrough")
        for (const f of o)
          c.push({
            key: { status: "valid", value: f },
            value: { status: "valid", value: r.data[f] }
          });
      else if (d === "strict")
        o.length > 0 && (h(r, {
          code: l.unrecognized_keys,
          keys: o
        }), s.dirty());
      else if (d !== "strip") throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const d = this._def.catchall;
      for (const f of o) {
        const _ = r.data[f];
        c.push({
          key: { status: "valid", value: f },
          value: d._parse(
            new Q(r, _, r.path, f)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: f in r.data
        });
      }
    }
    return r.common.async ? Promise.resolve().then(() => P(this, null, function* () {
      const d = [];
      for (const f of c) {
        const _ = yield f.key, I = yield f.value;
        d.push({
          key: _,
          value: I,
          alwaysSet: f.alwaysSet
        });
      }
      return d;
    })).then((d) => R.mergeObjectSync(s, d)) : R.mergeObjectSync(s, c);
  }
  get shape() {
    return this._def.shape();
  }
  strict(e) {
    return m.errToObj, new S(u(y(u({}, this._def), {
      unknownKeys: "strict"
    }), e !== void 0 ? {
      errorMap: (t, s) => {
        var r, a, i, o;
        const c = (i = (a = (r = this._def).errorMap) === null || a === void 0 ? void 0 : a.call(r, t, s).message) !== null && i !== void 0 ? i : s.defaultError;
        return t.code === "unrecognized_keys" ? {
          message: (o = m.errToObj(e).message) !== null && o !== void 0 ? o : c
        } : {
          message: c
        };
      }
    } : {}));
  }
  strip() {
    return new S(y(u({}, this._def), {
      unknownKeys: "strip"
    }));
  }
  passthrough() {
    return new S(y(u({}, this._def), {
      unknownKeys: "passthrough"
    }));
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(e) {
    return new S(y(u({}, this._def), {
      shape: () => u(u({}, this._def.shape()), e)
    }));
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(e) {
    return new S({
      unknownKeys: e._def.unknownKeys,
      catchall: e._def.catchall,
      shape: () => u(u({}, this._def.shape()), e._def.shape()),
      typeName: g.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(e, t) {
    return this.augment({ [e]: t });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(e) {
    return new S(y(u({}, this._def), {
      catchall: e
    }));
  }
  pick(e) {
    const t = {};
    return k.objectKeys(e).forEach((s) => {
      e[s] && this.shape[s] && (t[s] = this.shape[s]);
    }), new S(y(u({}, this._def), {
      shape: () => t
    }));
  }
  omit(e) {
    const t = {};
    return k.objectKeys(this.shape).forEach((s) => {
      e[s] || (t[s] = this.shape[s]);
    }), new S(y(u({}, this._def), {
      shape: () => t
    }));
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return be(this);
  }
  partial(e) {
    const t = {};
    return k.objectKeys(this.shape).forEach((s) => {
      const r = this.shape[s];
      e && !e[s] ? t[s] = r : t[s] = r.optional();
    }), new S(y(u({}, this._def), {
      shape: () => t
    }));
  }
  required(e) {
    const t = {};
    return k.objectKeys(this.shape).forEach((s) => {
      if (e && !e[s])
        t[s] = this.shape[s];
      else {
        let a = this.shape[s];
        for (; a instanceof Y; )
          a = a._def.innerType;
        t[s] = a;
      }
    }), new S(y(u({}, this._def), {
      shape: () => t
    }));
  }
  keyof() {
    return Xt(k.objectKeys(this.shape));
  }
}
S.create = (n, e) => new S(u({
  shape: () => n,
  unknownKeys: "strip",
  catchall: ie.create(),
  typeName: g.ZodObject
}, w(e)));
S.strictCreate = (n, e) => new S(u({
  shape: () => n,
  unknownKeys: "strict",
  catchall: ie.create(),
  typeName: g.ZodObject
}, w(e)));
S.lazycreate = (n, e) => new S(u({
  shape: n,
  unknownKeys: "strip",
  catchall: ie.create(),
  typeName: g.ZodObject
}, w(e)));
class Fe extends x {
  _parse(e) {
    const { ctx: t } = this._processInputParams(e), s = this._def.options;
    function r(a) {
      for (const o of a)
        if (o.result.status === "valid")
          return o.result;
      for (const o of a)
        if (o.result.status === "dirty")
          return t.common.issues.push(...o.ctx.common.issues), o.result;
      const i = a.map((o) => new U(o.ctx.common.issues));
      return h(t, {
        code: l.invalid_union,
        unionErrors: i
      }), v;
    }
    if (t.common.async)
      return Promise.all(s.map((a) => P(this, null, function* () {
        const i = y(u({}, t), {
          common: y(u({}, t.common), {
            issues: []
          }),
          parent: null
        });
        return {
          result: yield a._parseAsync({
            data: t.data,
            path: t.path,
            parent: i
          }),
          ctx: i
        };
      }))).then(r);
    {
      let a;
      const i = [];
      for (const c of s) {
        const d = y(u({}, t), {
          common: y(u({}, t.common), {
            issues: []
          }),
          parent: null
        }), f = c._parseSync({
          data: t.data,
          path: t.path,
          parent: d
        });
        if (f.status === "valid")
          return f;
        f.status === "dirty" && !a && (a = { result: f, ctx: d }), d.common.issues.length && i.push(d.common.issues);
      }
      if (a)
        return t.common.issues.push(...a.ctx.common.issues), a.result;
      const o = i.map((c) => new U(c));
      return h(t, {
        code: l.invalid_union,
        unionErrors: o
      }), v;
    }
  }
  get options() {
    return this._def.options;
  }
}
Fe.create = (n, e) => new Fe(u({
  options: n,
  typeName: g.ZodUnion
}, w(e)));
const re = (n) => n instanceof Ve ? re(n.schema) : n instanceof J ? re(n.innerType()) : n instanceof Ue ? [n.value] : n instanceof le ? n.options : n instanceof ze ? k.objectValues(n.enum) : n instanceof We ? re(n._def.innerType) : n instanceof $e ? [void 0] : n instanceof Pe ? [null] : n instanceof Y ? [void 0, ...re(n.unwrap())] : n instanceof fe ? [null, ...re(n.unwrap())] : n instanceof At || n instanceof qe ? re(n.unwrap()) : n instanceof Be ? re(n._def.innerType) : [];
class it extends x {
  _parse(e) {
    const { ctx: t } = this._processInputParams(e);
    if (t.parsedType !== p.object)
      return h(t, {
        code: l.invalid_type,
        expected: p.object,
        received: t.parsedType
      }), v;
    const s = this.discriminator, r = t.data[s], a = this.optionsMap.get(r);
    return a ? t.common.async ? a._parseAsync({
      data: t.data,
      path: t.path,
      parent: t
    }) : a._parseSync({
      data: t.data,
      path: t.path,
      parent: t
    }) : (h(t, {
      code: l.invalid_union_discriminator,
      options: Array.from(this.optionsMap.keys()),
      path: [s]
    }), v);
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(e, t, s) {
    const r = /* @__PURE__ */ new Map();
    for (const a of t) {
      const i = re(a.shape[e]);
      if (!i.length)
        throw new Error(`A discriminator value for key \`${e}\` could not be extracted from all schema options`);
      for (const o of i) {
        if (r.has(o))
          throw new Error(`Discriminator property ${String(e)} has duplicate value ${String(o)}`);
        r.set(o, a);
      }
    }
    return new it(u({
      typeName: g.ZodDiscriminatedUnion,
      discriminator: e,
      options: t,
      optionsMap: r
    }, w(s)));
  }
}
function gt(n, e) {
  const t = ae(n), s = ae(e);
  if (n === e)
    return { valid: !0, data: n };
  if (t === p.object && s === p.object) {
    const r = k.objectKeys(e), a = k.objectKeys(n).filter((o) => r.indexOf(o) !== -1), i = u(u({}, n), e);
    for (const o of a) {
      const c = gt(n[o], e[o]);
      if (!c.valid)
        return { valid: !1 };
      i[o] = c.data;
    }
    return { valid: !0, data: i };
  } else if (t === p.array && s === p.array) {
    if (n.length !== e.length)
      return { valid: !1 };
    const r = [];
    for (let a = 0; a < n.length; a++) {
      const i = n[a], o = e[a], c = gt(i, o);
      if (!c.valid)
        return { valid: !1 };
      r.push(c.data);
    }
    return { valid: !0, data: r };
  } else return t === p.date && s === p.date && +n == +e ? { valid: !0, data: n } : { valid: !1 };
}
class Le extends x {
  _parse(e) {
    const { status: t, ctx: s } = this._processInputParams(e), r = (a, i) => {
      if (mt(a) || mt(i))
        return v;
      const o = gt(a.value, i.value);
      return o.valid ? ((yt(a) || yt(i)) && t.dirty(), { status: t.value, value: o.data }) : (h(s, {
        code: l.invalid_intersection_types
      }), v);
    };
    return s.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: s.data,
        path: s.path,
        parent: s
      }),
      this._def.right._parseAsync({
        data: s.data,
        path: s.path,
        parent: s
      })
    ]).then(([a, i]) => r(a, i)) : r(this._def.left._parseSync({
      data: s.data,
      path: s.path,
      parent: s
    }), this._def.right._parseSync({
      data: s.data,
      path: s.path,
      parent: s
    }));
  }
}
Le.create = (n, e, t) => new Le(u({
  left: n,
  right: e,
  typeName: g.ZodIntersection
}, w(t)));
class ee extends x {
  _parse(e) {
    const { status: t, ctx: s } = this._processInputParams(e);
    if (s.parsedType !== p.array)
      return h(s, {
        code: l.invalid_type,
        expected: p.array,
        received: s.parsedType
      }), v;
    if (s.data.length < this._def.items.length)
      return h(s, {
        code: l.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), v;
    !this._def.rest && s.data.length > this._def.items.length && (h(s, {
      code: l.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), t.dirty());
    const a = [...s.data].map((i, o) => {
      const c = this._def.items[o] || this._def.rest;
      return c ? c._parse(new Q(s, i, s.path, o)) : null;
    }).filter((i) => !!i);
    return s.common.async ? Promise.all(a).then((i) => R.mergeArray(t, i)) : R.mergeArray(t, a);
  }
  get items() {
    return this._def.items;
  }
  rest(e) {
    return new ee(y(u({}, this._def), {
      rest: e
    }));
  }
}
ee.create = (n, e) => {
  if (!Array.isArray(n))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new ee(u({
    items: n,
    typeName: g.ZodTuple,
    rest: null
  }, w(e)));
};
class De extends x {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: t, ctx: s } = this._processInputParams(e);
    if (s.parsedType !== p.object)
      return h(s, {
        code: l.invalid_type,
        expected: p.object,
        received: s.parsedType
      }), v;
    const r = [], a = this._def.keyType, i = this._def.valueType;
    for (const o in s.data)
      r.push({
        key: a._parse(new Q(s, o, s.path, o)),
        value: i._parse(new Q(s, s.data[o], s.path, o)),
        alwaysSet: o in s.data
      });
    return s.common.async ? R.mergeObjectAsync(t, r) : R.mergeObjectSync(t, r);
  }
  get element() {
    return this._def.valueType;
  }
  static create(e, t, s) {
    return t instanceof x ? new De(u({
      keyType: e,
      valueType: t,
      typeName: g.ZodRecord
    }, w(s))) : new De(u({
      keyType: q.create(),
      valueType: e,
      typeName: g.ZodRecord
    }, w(t)));
  }
}
class rt extends x {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: t, ctx: s } = this._processInputParams(e);
    if (s.parsedType !== p.map)
      return h(s, {
        code: l.invalid_type,
        expected: p.map,
        received: s.parsedType
      }), v;
    const r = this._def.keyType, a = this._def.valueType, i = [...s.data.entries()].map(([o, c], d) => ({
      key: r._parse(new Q(s, o, s.path, [d, "key"])),
      value: a._parse(new Q(s, c, s.path, [d, "value"]))
    }));
    if (s.common.async) {
      const o = /* @__PURE__ */ new Map();
      return Promise.resolve().then(() => P(this, null, function* () {
        for (const c of i) {
          const d = yield c.key, f = yield c.value;
          if (d.status === "aborted" || f.status === "aborted")
            return v;
          (d.status === "dirty" || f.status === "dirty") && t.dirty(), o.set(d.value, f.value);
        }
        return { status: t.value, value: o };
      }));
    } else {
      const o = /* @__PURE__ */ new Map();
      for (const c of i) {
        const d = c.key, f = c.value;
        if (d.status === "aborted" || f.status === "aborted")
          return v;
        (d.status === "dirty" || f.status === "dirty") && t.dirty(), o.set(d.value, f.value);
      }
      return { status: t.value, value: o };
    }
  }
}
rt.create = (n, e, t) => new rt(u({
  valueType: e,
  keyType: n,
  typeName: g.ZodMap
}, w(t)));
class ve extends x {
  _parse(e) {
    const { status: t, ctx: s } = this._processInputParams(e);
    if (s.parsedType !== p.set)
      return h(s, {
        code: l.invalid_type,
        expected: p.set,
        received: s.parsedType
      }), v;
    const r = this._def;
    r.minSize !== null && s.data.size < r.minSize.value && (h(s, {
      code: l.too_small,
      minimum: r.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: r.minSize.message
    }), t.dirty()), r.maxSize !== null && s.data.size > r.maxSize.value && (h(s, {
      code: l.too_big,
      maximum: r.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: r.maxSize.message
    }), t.dirty());
    const a = this._def.valueType;
    function i(c) {
      const d = /* @__PURE__ */ new Set();
      for (const f of c) {
        if (f.status === "aborted")
          return v;
        f.status === "dirty" && t.dirty(), d.add(f.value);
      }
      return { status: t.value, value: d };
    }
    const o = [...s.data.values()].map((c, d) => a._parse(new Q(s, c, s.path, d)));
    return s.common.async ? Promise.all(o).then((c) => i(c)) : i(o);
  }
  min(e, t) {
    return new ve(y(u({}, this._def), {
      minSize: { value: e, message: m.toString(t) }
    }));
  }
  max(e, t) {
    return new ve(y(u({}, this._def), {
      maxSize: { value: e, message: m.toString(t) }
    }));
  }
  size(e, t) {
    return this.min(e, t).max(e, t);
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
ve.create = (n, e) => new ve(u({
  valueType: n,
  minSize: null,
  maxSize: null,
  typeName: g.ZodSet
}, w(e)));
class xe extends x {
  constructor() {
    super(...arguments), this.validate = this.implement;
  }
  _parse(e) {
    const { ctx: t } = this._processInputParams(e);
    if (t.parsedType !== p.function)
      return h(t, {
        code: l.invalid_type,
        expected: p.function,
        received: t.parsedType
      }), v;
    function s(o, c) {
      return et({
        data: o,
        path: t.path,
        errorMaps: [
          t.common.contextualErrorMap,
          t.schemaErrorMap,
          Qe(),
          ke
        ].filter((d) => !!d),
        issueData: {
          code: l.invalid_arguments,
          argumentsError: c
        }
      });
    }
    function r(o, c) {
      return et({
        data: o,
        path: t.path,
        errorMaps: [
          t.common.contextualErrorMap,
          t.schemaErrorMap,
          Qe(),
          ke
        ].filter((d) => !!d),
        issueData: {
          code: l.invalid_return_type,
          returnTypeError: c
        }
      });
    }
    const a = { errorMap: t.common.contextualErrorMap }, i = t.data;
    if (this._def.returns instanceof Se) {
      const o = this;
      return $(function(...c) {
        return P(this, null, function* () {
          const d = new U([]), f = yield o._def.args.parseAsync(c, a).catch((A) => {
            throw d.addIssue(s(c, A)), d;
          }), _ = yield Reflect.apply(i, this, f);
          return yield o._def.returns._def.type.parseAsync(_, a).catch((A) => {
            throw d.addIssue(r(_, A)), d;
          });
        });
      });
    } else {
      const o = this;
      return $(function(...c) {
        const d = o._def.args.safeParse(c, a);
        if (!d.success)
          throw new U([s(c, d.error)]);
        const f = Reflect.apply(i, this, d.data), _ = o._def.returns.safeParse(f, a);
        if (!_.success)
          throw new U([r(f, _.error)]);
        return _.data;
      });
    }
  }
  parameters() {
    return this._def.args;
  }
  returnType() {
    return this._def.returns;
  }
  args(...e) {
    return new xe(y(u({}, this._def), {
      args: ee.create(e).rest(me.create())
    }));
  }
  returns(e) {
    return new xe(y(u({}, this._def), {
      returns: e
    }));
  }
  implement(e) {
    return this.parse(e);
  }
  strictImplement(e) {
    return this.parse(e);
  }
  static create(e, t, s) {
    return new xe(u({
      args: e || ee.create([]).rest(me.create()),
      returns: t || me.create(),
      typeName: g.ZodFunction
    }, w(s)));
  }
}
class Ve extends x {
  get schema() {
    return this._def.getter();
  }
  _parse(e) {
    const { ctx: t } = this._processInputParams(e);
    return this._def.getter()._parse({ data: t.data, path: t.path, parent: t });
  }
}
Ve.create = (n, e) => new Ve(u({
  getter: n,
  typeName: g.ZodLazy
}, w(e)));
class Ue extends x {
  _parse(e) {
    if (e.data !== this._def.value) {
      const t = this._getOrReturnCtx(e);
      return h(t, {
        received: t.data,
        code: l.invalid_literal,
        expected: this._def.value
      }), v;
    }
    return { status: "valid", value: e.data };
  }
  get value() {
    return this._def.value;
  }
}
Ue.create = (n, e) => new Ue(u({
  value: n,
  typeName: g.ZodLiteral
}, w(e)));
function Xt(n, e) {
  return new le(u({
    values: n,
    typeName: g.ZodEnum
  }, w(e)));
}
class le extends x {
  constructor() {
    super(...arguments), Ce.set(this, void 0);
  }
  _parse(e) {
    if (typeof e.data != "string") {
      const t = this._getOrReturnCtx(e), s = this._def.values;
      return h(t, {
        expected: k.joinValues(s),
        received: t.parsedType,
        code: l.invalid_type
      }), v;
    }
    if (tt(this, Ce) || Ht(this, Ce, new Set(this._def.values)), !tt(this, Ce).has(e.data)) {
      const t = this._getOrReturnCtx(e), s = this._def.values;
      return h(t, {
        received: t.data,
        code: l.invalid_enum_value,
        options: s
      }), v;
    }
    return $(e.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const e = {};
    for (const t of this._def.values)
      e[t] = t;
    return e;
  }
  get Values() {
    const e = {};
    for (const t of this._def.values)
      e[t] = t;
    return e;
  }
  get Enum() {
    const e = {};
    for (const t of this._def.values)
      e[t] = t;
    return e;
  }
  extract(e, t = this._def) {
    return le.create(e, u(u({}, this._def), t));
  }
  exclude(e, t = this._def) {
    return le.create(this.options.filter((s) => !e.includes(s)), u(u({}, this._def), t));
  }
}
Ce = /* @__PURE__ */ new WeakMap();
le.create = Xt;
class ze extends x {
  constructor() {
    super(...arguments), Ie.set(this, void 0);
  }
  _parse(e) {
    const t = k.getValidEnumValues(this._def.values), s = this._getOrReturnCtx(e);
    if (s.parsedType !== p.string && s.parsedType !== p.number) {
      const r = k.objectValues(t);
      return h(s, {
        expected: k.joinValues(r),
        received: s.parsedType,
        code: l.invalid_type
      }), v;
    }
    if (tt(this, Ie) || Ht(this, Ie, new Set(k.getValidEnumValues(this._def.values))), !tt(this, Ie).has(e.data)) {
      const r = k.objectValues(t);
      return h(s, {
        received: s.data,
        code: l.invalid_enum_value,
        options: r
      }), v;
    }
    return $(e.data);
  }
  get enum() {
    return this._def.values;
  }
}
Ie = /* @__PURE__ */ new WeakMap();
ze.create = (n, e) => new ze(u({
  values: n,
  typeName: g.ZodNativeEnum
}, w(e)));
class Se extends x {
  unwrap() {
    return this._def.type;
  }
  _parse(e) {
    const { ctx: t } = this._processInputParams(e);
    if (t.parsedType !== p.promise && t.common.async === !1)
      return h(t, {
        code: l.invalid_type,
        expected: p.promise,
        received: t.parsedType
      }), v;
    const s = t.parsedType === p.promise ? t.data : Promise.resolve(t.data);
    return $(s.then((r) => this._def.type.parseAsync(r, {
      path: t.path,
      errorMap: t.common.contextualErrorMap
    })));
  }
}
Se.create = (n, e) => new Se(u({
  type: n,
  typeName: g.ZodPromise
}, w(e)));
class J extends x {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === g.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(e) {
    const { status: t, ctx: s } = this._processInputParams(e), r = this._def.effect || null, a = {
      addIssue: (i) => {
        h(s, i), i.fatal ? t.abort() : t.dirty();
      },
      get path() {
        return s.path;
      }
    };
    if (a.addIssue = a.addIssue.bind(a), r.type === "preprocess") {
      const i = r.transform(s.data, a);
      if (s.common.async)
        return Promise.resolve(i).then((o) => P(this, null, function* () {
          if (t.value === "aborted")
            return v;
          const c = yield this._def.schema._parseAsync({
            data: o,
            path: s.path,
            parent: s
          });
          return c.status === "aborted" ? v : c.status === "dirty" || t.value === "dirty" ? we(c.value) : c;
        }));
      {
        if (t.value === "aborted")
          return v;
        const o = this._def.schema._parseSync({
          data: i,
          path: s.path,
          parent: s
        });
        return o.status === "aborted" ? v : o.status === "dirty" || t.value === "dirty" ? we(o.value) : o;
      }
    }
    if (r.type === "refinement") {
      const i = (o) => {
        const c = r.refinement(o, a);
        if (s.common.async)
          return Promise.resolve(c);
        if (c instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return o;
      };
      if (s.common.async === !1) {
        const o = this._def.schema._parseSync({
          data: s.data,
          path: s.path,
          parent: s
        });
        return o.status === "aborted" ? v : (o.status === "dirty" && t.dirty(), i(o.value), { status: t.value, value: o.value });
      } else
        return this._def.schema._parseAsync({ data: s.data, path: s.path, parent: s }).then((o) => o.status === "aborted" ? v : (o.status === "dirty" && t.dirty(), i(o.value).then(() => ({ status: t.value, value: o.value }))));
    }
    if (r.type === "transform")
      if (s.common.async === !1) {
        const i = this._def.schema._parseSync({
          data: s.data,
          path: s.path,
          parent: s
        });
        if (!ye(i))
          return i;
        const o = r.transform(i.value, a);
        if (o instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: t.value, value: o };
      } else
        return this._def.schema._parseAsync({ data: s.data, path: s.path, parent: s }).then((i) => ye(i) ? Promise.resolve(r.transform(i.value, a)).then((o) => ({ status: t.value, value: o })) : i);
    k.assertNever(r);
  }
}
J.create = (n, e, t) => new J(u({
  schema: n,
  typeName: g.ZodEffects,
  effect: e
}, w(t)));
J.createWithPreprocess = (n, e, t) => new J(u({
  schema: e,
  effect: { type: "preprocess", transform: n },
  typeName: g.ZodEffects
}, w(t)));
class Y extends x {
  _parse(e) {
    return this._getType(e) === p.undefined ? $(void 0) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
Y.create = (n, e) => new Y(u({
  innerType: n,
  typeName: g.ZodOptional
}, w(e)));
class fe extends x {
  _parse(e) {
    return this._getType(e) === p.null ? $(null) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
fe.create = (n, e) => new fe(u({
  innerType: n,
  typeName: g.ZodNullable
}, w(e)));
class We extends x {
  _parse(e) {
    const { ctx: t } = this._processInputParams(e);
    let s = t.data;
    return t.parsedType === p.undefined && (s = this._def.defaultValue()), this._def.innerType._parse({
      data: s,
      path: t.path,
      parent: t
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
We.create = (n, e) => new We(u({
  innerType: n,
  typeName: g.ZodDefault,
  defaultValue: typeof e.default == "function" ? e.default : () => e.default
}, w(e)));
class Be extends x {
  _parse(e) {
    const { ctx: t } = this._processInputParams(e), s = y(u({}, t), {
      common: y(u({}, t.common), {
        issues: []
      })
    }), r = this._def.innerType._parse({
      data: s.data,
      path: s.path,
      parent: u({}, s)
    });
    return Ze(r) ? r.then((a) => ({
      status: "valid",
      value: a.status === "valid" ? a.value : this._def.catchValue({
        get error() {
          return new U(s.common.issues);
        },
        input: s.data
      })
    })) : {
      status: "valid",
      value: r.status === "valid" ? r.value : this._def.catchValue({
        get error() {
          return new U(s.common.issues);
        },
        input: s.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
Be.create = (n, e) => new Be(u({
  innerType: n,
  typeName: g.ZodCatch,
  catchValue: typeof e.catch == "function" ? e.catch : () => e.catch
}, w(e)));
class at extends x {
  _parse(e) {
    if (this._getType(e) !== p.nan) {
      const s = this._getOrReturnCtx(e);
      return h(s, {
        code: l.invalid_type,
        expected: p.nan,
        received: s.parsedType
      }), v;
    }
    return { status: "valid", value: e.data };
  }
}
at.create = (n) => new at(u({
  typeName: g.ZodNaN
}, w(n)));
const Vn = Symbol("zod_brand");
class At extends x {
  _parse(e) {
    const { ctx: t } = this._processInputParams(e), s = t.data;
    return this._def.type._parse({
      data: s,
      path: t.path,
      parent: t
    });
  }
  unwrap() {
    return this._def.type;
  }
}
class Je extends x {
  _parse(e) {
    const { status: t, ctx: s } = this._processInputParams(e);
    if (s.common.async)
      return P(this, null, function* () {
        const a = yield this._def.in._parseAsync({
          data: s.data,
          path: s.path,
          parent: s
        });
        return a.status === "aborted" ? v : a.status === "dirty" ? (t.dirty(), we(a.value)) : this._def.out._parseAsync({
          data: a.value,
          path: s.path,
          parent: s
        });
      });
    {
      const r = this._def.in._parseSync({
        data: s.data,
        path: s.path,
        parent: s
      });
      return r.status === "aborted" ? v : r.status === "dirty" ? (t.dirty(), {
        status: "dirty",
        value: r.value
      }) : this._def.out._parseSync({
        data: r.value,
        path: s.path,
        parent: s
      });
    }
  }
  static create(e, t) {
    return new Je({
      in: e,
      out: t,
      typeName: g.ZodPipeline
    });
  }
}
class qe extends x {
  _parse(e) {
    const t = this._def.innerType._parse(e), s = (r) => (ye(r) && (r.value = Object.freeze(r.value)), r);
    return Ze(t) ? t.then((r) => s(r)) : s(t);
  }
  unwrap() {
    return this._def.innerType;
  }
}
qe.create = (n, e) => new qe(u({
  innerType: n,
  typeName: g.ZodReadonly
}, w(e)));
function Yt(n, e = {}, t) {
  return n ? Te.create().superRefine((s, r) => {
    var a, i;
    if (!n(s)) {
      const o = typeof e == "function" ? e(s) : typeof e == "string" ? { message: e } : e, c = (i = (a = o.fatal) !== null && a !== void 0 ? a : t) !== null && i !== void 0 ? i : !0, d = typeof o == "string" ? { message: o } : o;
      r.addIssue(y(u({ code: "custom" }, d), { fatal: c }));
    }
  }) : Te.create();
}
const Un = {
  object: S.lazycreate
};
var g;
(function(n) {
  n.ZodString = "ZodString", n.ZodNumber = "ZodNumber", n.ZodNaN = "ZodNaN", n.ZodBigInt = "ZodBigInt", n.ZodBoolean = "ZodBoolean", n.ZodDate = "ZodDate", n.ZodSymbol = "ZodSymbol", n.ZodUndefined = "ZodUndefined", n.ZodNull = "ZodNull", n.ZodAny = "ZodAny", n.ZodUnknown = "ZodUnknown", n.ZodNever = "ZodNever", n.ZodVoid = "ZodVoid", n.ZodArray = "ZodArray", n.ZodObject = "ZodObject", n.ZodUnion = "ZodUnion", n.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", n.ZodIntersection = "ZodIntersection", n.ZodTuple = "ZodTuple", n.ZodRecord = "ZodRecord", n.ZodMap = "ZodMap", n.ZodSet = "ZodSet", n.ZodFunction = "ZodFunction", n.ZodLazy = "ZodLazy", n.ZodLiteral = "ZodLiteral", n.ZodEnum = "ZodEnum", n.ZodEffects = "ZodEffects", n.ZodNativeEnum = "ZodNativeEnum", n.ZodOptional = "ZodOptional", n.ZodNullable = "ZodNullable", n.ZodDefault = "ZodDefault", n.ZodCatch = "ZodCatch", n.ZodPromise = "ZodPromise", n.ZodBranded = "ZodBranded", n.ZodPipeline = "ZodPipeline", n.ZodReadonly = "ZodReadonly";
})(g || (g = {}));
const zn = (n, e = {
  message: `Input not instance of ${n.name}`
}) => Yt((t) => t instanceof n, e), Qt = q.create, en = ue.create, Wn = at.create, Bn = de.create, tn = Me.create, qn = ge.create, Hn = nt.create, Jn = $e.create, Gn = Pe.create, Kn = Te.create, Xn = me.create, Yn = ie.create, Qn = st.create, es = H.create, ts = S.create, ns = S.strictCreate, ss = Fe.create, rs = it.create, as = Le.create, is = ee.create, os = De.create, cs = rt.create, us = ve.create, ds = xe.create, ls = Ve.create, fs = Ue.create, hs = le.create, ps = ze.create, ms = Se.create, Pt = J.create, ys = Y.create, gs = fe.create, vs = J.createWithPreprocess, _s = Je.create, bs = () => Qt().optional(), ws = () => en().optional(), xs = () => tn().optional(), ks = {
  string: (n) => q.create(y(u({}, n), { coerce: !0 })),
  number: (n) => ue.create(y(u({}, n), { coerce: !0 })),
  boolean: (n) => Me.create(y(u({}, n), {
    coerce: !0
  })),
  bigint: (n) => de.create(y(u({}, n), { coerce: !0 })),
  date: (n) => ge.create(y(u({}, n), { coerce: !0 }))
}, Ts = v;
var C = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  defaultErrorMap: ke,
  setErrorMap: vn,
  getErrorMap: Qe,
  makeIssue: et,
  EMPTY_PATH: _n,
  addIssueToContext: h,
  ParseStatus: R,
  INVALID: v,
  DIRTY: we,
  OK: $,
  isAborted: mt,
  isDirty: yt,
  isValid: ye,
  isAsync: Ze,
  get util() {
    return k;
  },
  get objectUtil() {
    return pt;
  },
  ZodParsedType: p,
  getParsedType: ae,
  ZodType: x,
  datetimeRegex: Kt,
  ZodString: q,
  ZodNumber: ue,
  ZodBigInt: de,
  ZodBoolean: Me,
  ZodDate: ge,
  ZodSymbol: nt,
  ZodUndefined: $e,
  ZodNull: Pe,
  ZodAny: Te,
  ZodUnknown: me,
  ZodNever: ie,
  ZodVoid: st,
  ZodArray: H,
  ZodObject: S,
  ZodUnion: Fe,
  ZodDiscriminatedUnion: it,
  ZodIntersection: Le,
  ZodTuple: ee,
  ZodRecord: De,
  ZodMap: rt,
  ZodSet: ve,
  ZodFunction: xe,
  ZodLazy: Ve,
  ZodLiteral: Ue,
  ZodEnum: le,
  ZodNativeEnum: ze,
  ZodPromise: Se,
  ZodEffects: J,
  ZodTransformer: J,
  ZodOptional: Y,
  ZodNullable: fe,
  ZodDefault: We,
  ZodCatch: Be,
  ZodNaN: at,
  BRAND: Vn,
  ZodBranded: At,
  ZodPipeline: Je,
  ZodReadonly: qe,
  custom: Yt,
  Schema: x,
  ZodSchema: x,
  late: Un,
  get ZodFirstPartyTypeKind() {
    return g;
  },
  coerce: ks,
  any: Kn,
  array: es,
  bigint: Bn,
  boolean: tn,
  date: qn,
  discriminatedUnion: rs,
  effect: Pt,
  enum: hs,
  function: ds,
  instanceof: zn,
  intersection: as,
  lazy: ls,
  literal: fs,
  map: cs,
  nan: Wn,
  nativeEnum: ps,
  never: Yn,
  null: Gn,
  nullable: gs,
  number: en,
  object: ts,
  oboolean: xs,
  onumber: ws,
  optional: ys,
  ostring: bs,
  pipeline: _s,
  preprocess: vs,
  promise: ms,
  record: os,
  set: us,
  strictObject: ns,
  string: Qt,
  symbol: Hn,
  transformer: Pt,
  tuple: is,
  undefined: Jn,
  union: ss,
  unknown: Xn,
  void: Qn,
  NEVER: Ts,
  ZodIssueCode: l,
  quotelessJson: gn,
  ZodError: U
});
const Ss = C.object({
  language: C.enum(["typescript", "javascript"]).optional(),
  disableMarkedForExport: C.boolean().optional()
}).and(
  C.union([
    C.object({
      framework: C.literal("react"),
      model: C.string().optional(),
      styling: C.enum([
        "plain_css",
        "css_modules",
        "styled_components",
        "tailwind",
        "sass",
        "scss",
        "inline_styles"
      ]),
      uiLibrary: C.enum(["mui", "antd", "radix", "shadcn"]).optional(),
      enableUILibraryTheming: C.boolean().optional(),
      enableCompactStructure: C.boolean().optional(),
      enableAutoSplit: C.boolean().optional(),
      autoSplitThreshold: C.number().optional()
    }),
    C.object({
      framework: C.literal("html"),
      styling: C.enum(["plain_css", "inline_styles"]),
      enableTranslation: C.boolean().optional()
    })
  ])
), Es = (n) => {
  const e = Ss.safeParse(n);
  if (e.success === !1) {
    const t = new Error("Invalid codegen settings");
    throw t.cause = e.error, t;
  }
  return e.data;
};
var D, He;
class Zr {
  constructor({
    auth: e,
    apiBaseAddress: t = "https://public-api.animaapp.com"
  } = {}) {
    ct(this, D);
    ct(this, He);
    ut(this, He, t), e && (this.auth = e);
  }
  hasAuth() {
    return !!B(this, D);
  }
  set auth(e) {
    ut(this, D, e);
  }
  get headers() {
    const e = {
      "Content-Type": "application/json"
    };
    return B(this, D) && (e.Authorization = `Bearer ${B(this, D).token}`, "teamId" in B(this, D) && (e["X-Team-Id"] = B(this, D).teamId)), e;
  }
  generateCode(s) {
    return P(this, arguments, function* (e, t = {}) {
      var _, I, A, O, Z, W, te, oe;
      if (this.hasAuth() === !1)
        throw new Error('It needs to set "auth" before calling this method.');
      const r = {}, a = Es(e.settings);
      let i = e.tracking;
      B(this, D) && "userId" in B(this, D) && B(this, D).userId && (i != null && i.externalId || (i = { externalId: B(this, D).userId }));
      const o = yield fetch(`${B(this, He)}/v1/codegen`, {
        method: "POST",
        headers: y(u({}, this.headers), {
          Accept: "text/event-stream"
        }),
        body: JSON.stringify({
          tracking: i,
          fileKey: e.fileKey,
          figmaToken: e.figmaToken,
          nodesId: e.nodesId,
          assetsStorage: e.assetsStorage,
          language: a.language,
          model: a.model,
          framework: a.framework,
          styling: a.styling,
          uiLibrary: a.uiLibrary,
          enableTranslation: a.enableTranslation,
          enableUILibraryTheming: a.enableUILibraryTheming,
          enableCompactStructure: a.enableCompactStructure,
          enableAutoSplit: a.enableAutoSplit,
          autoSplitThreshold: a.autoSplitThreshold,
          disableMarkedForExport: a.disableMarkedForExport
        })
      });
      if (!o.ok) {
        let N;
        try {
          N = (yield o.json()).message || `HTTP error! status: ${o.status}`;
        } catch (ne) {
          N = `HTTP error! status: ${o.status}`;
        }
        throw new Ae({
          name: "HTTP Error",
          reason: N,
          status: o.status
        });
      }
      if (!o.body)
        throw new Ae({
          name: "Stream Error",
          reason: "Response body is null",
          status: o.status
        });
      const c = o.body.getReader(), d = new TextDecoder();
      let f = "";
      try {
        for (; ; ) {
          const { done: N, value: ne } = yield c.read();
          if (N)
            break;
          f += d.decode(ne, { stream: !0 });
          const Ge = f.split(`
`);
          f = Ge.pop() || "";
          for (const _e of Ge)
            if (!(!_e.trim() || _e.startsWith(":")) && _e.startsWith("data: ")) {
              let b;
              try {
                b = JSON.parse(_e.slice(6));
              } catch (ot) {
                continue;
              }
              switch (b.type) {
                case "queueing": {
                  typeof t == "function" ? t(b) : (_ = t.onQueueing) == null || _.call(t);
                  break;
                }
                case "start": {
                  r.sessionId = b.sessionId, typeof t == "function" ? t(b) : (I = t.onStart) == null || I.call(t, { sessionId: b.sessionId });
                  break;
                }
                case "pre_codegen": {
                  typeof t == "function" ? t(b) : (A = t.onPreCodegen) == null || A.call(t, { message: b.message });
                  break;
                }
                case "assets_uploaded": {
                  typeof t == "function" ? t(b) : (O = t.onAssetsUploaded) == null || O.call(t);
                  break;
                }
                case "assets_list": {
                  r.assets = b.payload.assets, typeof t == "function" ? t(b) : (Z = t.onAssetsList) == null || Z.call(t, b.payload);
                  break;
                }
                case "figma_metadata": {
                  r.figmaFileName = b.figmaFileName, r.figmaSelectedFrameName = b.figmaSelectedFrameName, typeof t == "function" ? t(b) : (W = t.onFigmaMetadata) == null || W.call(t, {
                    figmaFileName: b.figmaFileName,
                    figmaSelectedFrameName: b.figmaSelectedFrameName
                  });
                  break;
                }
                case "generating_code": {
                  b.payload.status === "success" && (r.files = b.payload.files), typeof t == "function" ? t(b) : (te = t.onGeneratingCode) == null || te.call(t, {
                    status: b.payload.status,
                    progress: b.payload.progress,
                    files: b.payload.files
                  });
                  break;
                }
                case "codegen_completed": {
                  typeof t == "function" ? t(b) : (oe = t.onCodegenCompleted) == null || oe.call(t);
                  break;
                }
                case "error":
                  throw new Ae({
                    name: b.payload.errorName,
                    reason: b.payload.reason
                  });
                case "done": {
                  if (!r.files)
                    throw new Ae({
                      name: "Invalid response",
                      reason: "No files found"
                    });
                  return r.tokenUsage = b.payload.tokenUsage, r;
                }
              }
            }
        }
      } finally {
        c.cancel();
      }
      throw new Ae({
        name: "Connection",
        reason: "Connection closed before the 'done' message",
        status: 500
      });
    });
  }
}
D = new WeakMap(), He = new WeakMap();
const Mr = (n) => {
  var e;
  if (!n)
    return [!1, "", ""];
  try {
    const t = new URL(n), s = t.pathname;
    if (t.origin !== "https://www.figma.com")
      return [!1, "", ""];
    const r = ((e = t.searchParams.get("node-id")) != null ? e : "").replace(/-/g, ":"), a = s.split("/")[2];
    return [(s.startsWith("/file/") && t.searchParams.get("type") !== "whiteboard" || s.startsWith("/design/")) && a.length === 22, a, r];
  } catch (t) {
    return [!1, "", ""];
  }
}, $r = ({
  fileKey: n,
  nodeId: e
}) => {
  const t = new URL("https://www.figma.com");
  return t.pathname = `design/${n}`, e && t.searchParams.set("node-id", e.replace(":", "-")), t;
};
class Pr extends Error {
  constructor(e, t) {
    super(e), this.response = t;
  }
}
const Fr = ({
  files: n,
  screenPath: e = "src/screens"
}) => {
  const t = {}, s = /* @__PURE__ */ new Set();
  function r(a) {
    if (s.has(a) || !n[a])
      return;
    s.add(a), t[a] = n[a], As(n[a].content).forEach((o) => {
      try {
        const c = Os(a, o);
        if (c.startsWith("src/")) {
          const d = c.split("/").slice(0, -1).join("/");
          Cs(n, d).forEach((_) => {
            s.has(_) || r(_);
          });
        }
      } catch (c) {
        console.warn(
          `Failed to resolve import ${o} in ${a}:`,
          c
        );
      }
    });
  }
  return Object.entries(n).forEach(([a, i]) => {
    a.startsWith(e) ? r(a) : a.startsWith("src/") || (t[a] = i);
  }), t;
};
function As(n) {
  const e = /import.*?["']([^"']+)["']/g, t = /export.*from\s+["']([^"']+)["']/g, s = [];
  let r;
  for (; (r = e.exec(n)) !== null; )
    s.push(r[1]);
  for (; (r = t.exec(n)) !== null; )
    s.push(r[1]);
  return [...new Set(s)];
}
function Os(n, e) {
  if (!e.startsWith("."))
    return e;
  const t = n.split("/").slice(0, -1), s = e.split("/"), r = [...t];
  for (const a of s)
    a === ".." ? r.pop() : a !== "." && r.push(a);
  return r.join("/");
}
function Cs(n, e) {
  return Object.keys(n).filter((t) => t.startsWith(e));
}
const nn = "Figma Token Issue";
class Is extends Error {
  constructor({ fileKey: e, reason: t }) {
    super(nn), this.fileKey = e, this.reason = t;
  }
}
const sn = "Rate Limit Exceeded";
class Ns extends Error {
  constructor({ fileKey: e }) {
    super(sn), this.fileKey = e;
  }
}
const rn = "Not Found";
class js extends Error {
  constructor({ fileKey: e }) {
    super(rn), this.fileKey = e;
  }
}
const Rs = (n) => n.message === rn, an = "Unknown Figma API Exception";
class Zs extends Error {
  constructor({ fileKey: e, cause: t }) {
    super(an), this.name = "UnknownFigmaApiException", this.fileKey = e, this.cause = t;
  }
}
const Lr = (n) => n.message === an, Ms = (n) => n.message === sn, $s = (n) => [nn, ...[
  "Invalid Figma token",
  "Figma token expired"
]].includes(
  n.message
), Ps = (n, e) => {
  var s, r, a, i;
  const t = ((s = n == null ? void 0 : n.cause) == null ? void 0 : s.body) || n.body;
  throw (t == null ? void 0 : t.status) === 403 ? new Is({
    fileKey: e,
    reason: (((a = (r = n == null ? void 0 : n.cause) == null ? void 0 : r.body) == null ? void 0 : a.reason) || ((i = n.body) == null ? void 0 : i.reason) || "Access denied").toString()
  }) : (t == null ? void 0 : t.status) === 429 ? new Ns({ fileKey: e }) : (t == null ? void 0 : t.status) === 404 ? new js({ fileKey: e }) : new Zs({ fileKey: e, cause: n });
}, Dr = (n) => Rs(n) ? "NotFound" : Ms(n) ? "RateLimitExceeded" : $s(n) ? "FigmaTokenIssue" : "UnknownFigmaApiException";
var Fs = Object.defineProperty, Ls = Object.defineProperties, Ds = Object.getOwnPropertyDescriptors, Ft = Object.getOwnPropertySymbols, Vs = Object.prototype.hasOwnProperty, Us = Object.prototype.propertyIsEnumerable, Lt = (n, e) => (e = Symbol[n]) ? e : Symbol.for("Symbol." + n), on = (n) => {
  throw TypeError(n);
}, Dt = (n, e, t) => e in n ? Fs(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, V = (n, e) => {
  for (var t in e || (e = {}))
    Vs.call(e, t) && Dt(n, t, e[t]);
  if (Ft)
    for (var t of Ft(e))
      Us.call(e, t) && Dt(n, t, e[t]);
  return n;
}, Ot = (n, e) => Ls(n, Ds(e)), Ct = (n, e, t) => e.has(n) || on("Cannot " + t), T = (n, e, t) => (Ct(n, e, "read from private field"), t ? t.call(n) : e.get(n)), z = (n, e, t) => e.has(n) ? on("Cannot add the same private member more than once") : e instanceof WeakSet ? e.add(n) : e.set(n, t), j = (n, e, t, s) => (Ct(n, e, "write to private field"), e.set(n, t), t), X = (n, e, t) => (Ct(n, e, "access private method"), t), E = (n, e, t) => new Promise((s, r) => {
  var a = (c) => {
    try {
      o(t.next(c));
    } catch (d) {
      r(d);
    }
  }, i = (c) => {
    try {
      o(t.throw(c));
    } catch (d) {
      r(d);
    }
  }, o = (c) => c.done ? s(c.value) : Promise.resolve(c.value).then(a, i);
  o((t = t.apply(n, e)).next());
}), zs = (n, e, t) => (e = n[Lt("asyncIterator")]) ? e.call(n) : (n = n[Lt("iterator")](), e = {}, t = (s, r) => (r = n[s]) && (e[s] = (a) => new Promise((i, o, c) => (a = r.call(n, a), c = a.done, Promise.resolve(a.value).then((d) => i({ value: d, done: c }), o)))), t("next"), t("return"), e), Ws = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
function Bs(n) {
  return n && n.__esModule && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n;
}
var vt = { exports: {} }, qs = vt.exports, Vt;
function Hs() {
  return Vt || (Vt = 1, function(n, e) {
    (function(t, s) {
      n.exports = s();
    })(qs, function() {
      var t = typeof Promise == "function", s = typeof self == "object" ? self : Ws, r = typeof Symbol != "undefined", a = typeof Map != "undefined", i = typeof Set != "undefined", o = typeof WeakMap != "undefined", c = typeof WeakSet != "undefined", d = typeof DataView != "undefined", f = r && typeof Symbol.iterator != "undefined", _ = r && typeof Symbol.toStringTag != "undefined", I = i && typeof Set.prototype.entries == "function", A = a && typeof Map.prototype.entries == "function", O = I && Object.getPrototypeOf((/* @__PURE__ */ new Set()).entries()), Z = A && Object.getPrototypeOf((/* @__PURE__ */ new Map()).entries()), W = f && typeof Array.prototype[Symbol.iterator] == "function", te = W && Object.getPrototypeOf([][Symbol.iterator]()), oe = f && typeof String.prototype[Symbol.iterator] == "function", N = oe && Object.getPrototypeOf(""[Symbol.iterator]()), ne = 8, Ge = -1;
      function _e(b) {
        var ot = typeof b;
        if (ot !== "object")
          return ot;
        if (b === null)
          return "null";
        if (b === s)
          return "global";
        if (Array.isArray(b) && (_ === !1 || !(Symbol.toStringTag in b)))
          return "Array";
        if (typeof window == "object" && window !== null) {
          if (typeof window.location == "object" && b === window.location)
            return "Location";
          if (typeof window.document == "object" && b === window.document)
            return "Document";
          if (typeof window.navigator == "object") {
            if (typeof window.navigator.mimeTypes == "object" && b === window.navigator.mimeTypes)
              return "MimeTypeArray";
            if (typeof window.navigator.plugins == "object" && b === window.navigator.plugins)
              return "PluginArray";
          }
          if ((typeof window.HTMLElement == "function" || typeof window.HTMLElement == "object") && b instanceof window.HTMLElement) {
            if (b.tagName === "BLOCKQUOTE")
              return "HTMLQuoteElement";
            if (b.tagName === "TD")
              return "HTMLTableDataCellElement";
            if (b.tagName === "TH")
              return "HTMLTableHeaderCellElement";
          }
        }
        var Nt = _ && b[Symbol.toStringTag];
        if (typeof Nt == "string")
          return Nt;
        var L = Object.getPrototypeOf(b);
        return L === RegExp.prototype ? "RegExp" : L === Date.prototype ? "Date" : t && L === Promise.prototype ? "Promise" : i && L === Set.prototype ? "Set" : a && L === Map.prototype ? "Map" : c && L === WeakSet.prototype ? "WeakSet" : o && L === WeakMap.prototype ? "WeakMap" : d && L === DataView.prototype ? "DataView" : a && L === Z ? "Map Iterator" : i && L === O ? "Set Iterator" : W && L === te ? "Array Iterator" : oe && L === N ? "String Iterator" : L === null ? "Object" : Object.prototype.toString.call(b).slice(ne, Ge);
      }
      return _e;
    });
  }(vt)), vt.exports;
}
var Js = Hs();
const Gs = /* @__PURE__ */ Bs(Js), It = typeof Buffer != "undefined", Ks = It && typeof Buffer.from != "undefined", Xs = It ? (
  /**
   * is value is Buffer?
   *
   * @param {*} value
   * @return {boolean}
   */
  function(n) {
    return Buffer.isBuffer(n);
  }
) : (
  /**
   * return false
   *
   * NOTE: for Buffer unsupported
   *
   * @return {boolean}
   */
  function() {
    return !1;
  }
), Ys = Ks ? (
  /**
   * copy Buffer
   *
   * @param {Buffer} value
   * @return {Buffer}
   */
  function(n) {
    return Buffer.from(n);
  }
) : It ? (
  /**
   * copy Buffer
   *
   * NOTE: for old node.js
   *
   * @param {Buffer} value
   * @return {Buffer}
   */
  function(n) {
    return new Buffer(n);
  }
) : (
  /**
   * shallow copy
   *
   * NOTE: for Buffer unsupported
   *
   * @param {*}
   * @return {*}
   */
  function(n) {
    return n;
  }
);
function Ee(n) {
  return Xs(n) ? "Buffer" : Gs(n);
}
const Qs = /* @__PURE__ */ new Set([
  "Arguments",
  "Array",
  "Map",
  "Object",
  "Set"
]);
function er(n, e, t = null) {
  switch (t || Ee(n)) {
    case "Arguments":
    case "Array":
    case "Object":
      return n[e];
    case "Map":
      return n.get(e);
    case "Set":
      return e;
  }
}
function _t(n) {
  return Qs.has(n);
}
function Ut(n, e, t, s = null) {
  switch (s || Ee(n)) {
    case "Arguments":
    case "Array":
    case "Object":
      n[e] = t;
      break;
    case "Map":
      n.set(e, t);
      break;
    case "Set":
      n.add(t);
      break;
  }
  return n;
}
const tr = typeof globalThis != "undefined" && globalThis !== null && globalThis.Object === Object && globalThis, nr = typeof global != "undefined" && global !== null && global.Object === Object && global, sr = typeof self != "undefined" && self !== null && self.Object === Object && self, lt = tr || nr || sr || Function("return this")();
function rr(n) {
  return n.slice(0);
}
function ar(n) {
  return new Boolean(n.valueOf());
}
function ir(n) {
  return new DataView(n.buffer);
}
function or(n) {
  return Ys(n);
}
function cr(n) {
  return new Date(n.getTime());
}
function ur(n) {
  return new Number(n);
}
function dr(n) {
  return new RegExp(n.source, n.flags);
}
function lr(n) {
  return new String(n);
}
function se(n, e) {
  return lt[e].from ? lt[e].from(n) : new lt[e](n);
}
function M(n) {
  return n;
}
function zt() {
  return [];
}
function fr() {
  return /* @__PURE__ */ new Map();
}
function hr() {
  return {};
}
function pr() {
  return /* @__PURE__ */ new Set();
}
const mr = /* @__PURE__ */ new Map([
  // deep copy
  ["ArrayBuffer", rr],
  ["Boolean", ar],
  ["Buffer", or],
  ["DataView", ir],
  ["Date", cr],
  ["Number", ur],
  ["RegExp", dr],
  ["String", lr],
  // typed arrays
  // TODO: pass bound function
  ["Float32Array", se],
  ["Float64Array", se],
  ["Int16Array", se],
  ["Int32Array", se],
  ["Int8Array", se],
  ["Uint16Array", se],
  ["Uint32Array", se],
  ["Uint8Array", se],
  ["Uint8ClampedArray", se],
  // shallow copy
  ["Array Iterator", M],
  ["Map Iterator", M],
  ["Promise", M],
  ["Set Iterator", M],
  ["String Iterator", M],
  ["function", M],
  ["global", M],
  // NOTE: WeakMap and WeakSet cannot get entries
  ["WeakMap", M],
  ["WeakSet", M],
  // primitives
  ["boolean", M],
  ["null", M],
  ["number", M],
  ["string", M],
  ["symbol", M],
  ["undefined", M],
  // collections
  // NOTE: return empty value, because recursively copy later.
  ["Arguments", zt],
  ["Array", zt],
  ["Map", fr],
  ["Object", hr],
  ["Set", pr]
  // NOTE: type-detect returns following types
  // 'Location'
  // 'Document'
  // 'MimeTypeArray'
  // 'PluginArray'
  // 'HTMLQuoteElement'
  // 'HTMLTableDataCellElement'
  // 'HTMLTableHeaderCellElement'
  // TODO: is type-detect never return 'object'?
  // 'object'
]);
function yr() {
}
function bt(n, e = null, t = yr) {
  arguments.length === 2 && typeof e == "function" && (t = e, e = null);
  const s = e || Ee(n), r = mr.get(s);
  if (s === "Object") {
    const a = t(n, s);
    if (a !== void 0)
      return a;
  }
  return r ? r(n, s) : n;
}
function Oe(n, e = {}) {
  typeof e == "function" && (e = {
    customizer: e
  });
  const {
    // TODO: before/after customizer
    customizer: t
    // TODO: max depth
    // depth = Infinity,
  } = e, s = Ee(n);
  if (!_t(s))
    return wt(n, null, null, null);
  const r = bt(n, s, t), a = new WeakMap([[n, r]]), i = new WeakSet([n]);
  return wt(n, r, a, i);
}
function wt(n, e, t, s, r) {
  const a = Ee(n), i = bt(n, a);
  if (!_t(a))
    return i;
  let o;
  switch (a) {
    case "Arguments":
    case "Array":
      o = Object.keys(n);
      break;
    case "Object":
      o = Object.keys(n), o.push(...Object.getOwnPropertySymbols(n));
      break;
    case "Map":
    case "Set":
      o = n.keys();
      break;
  }
  for (let c of o) {
    const d = er(n, c, a);
    if (s.has(d))
      Ut(e, c, t.get(d), a);
    else {
      const f = Ee(d), _ = bt(d, f);
      _t(f) && (t.set(d, _), s.add(d)), Ut(
        e,
        c,
        wt(
          d,
          _,
          t,
          s
        ),
        a
      );
    }
  }
  return e;
}
const gr = (n) => new Promise((e) => setTimeout(e, n));
var Ke, he, Xe, xt, cn;
class vr {
  constructor({ maxAttempts: e = 3, func: t }) {
    z(this, xt), z(this, Ke), z(this, he), z(this, Xe), j(this, Ke, e), j(this, Xe, t), j(this, he, 0);
  }
  run() {
    return E(this, null, function* () {
      try {
        return yield T(this, Xe).call(this);
      } catch (e) {
        if (j(this, he, T(this, he) + 1), T(this, he) > T(this, Ke))
          throw console.error("Max attempts reached"), e;
        const t = X(this, xt, cn).call(this);
        return yield gr(t), yield this.run();
      }
    });
  }
}
Ke = /* @__PURE__ */ new WeakMap(), he = /* @__PURE__ */ new WeakMap(), Xe = /* @__PURE__ */ new WeakMap(), xt = /* @__PURE__ */ new WeakSet(), cn = function() {
  return T(this, he) * 1e3 * 1.5;
};
function _r() {
  return typeof CompressionStream != "undefined";
}
function br(n) {
  return E(this, null, function* () {
    const e = new Blob([n]).stream().pipeThrough(new CompressionStream("gzip")), t = [];
    try {
      for (var s = zs(e), r, a, i; r = !(a = yield s.next()).done; r = !1) {
        const o = a.value;
        t.push(o);
      }
    } catch (o) {
      i = [o];
    } finally {
      try {
        r && (a = s.return) && (yield a.call(s));
      } finally {
        if (i)
          throw i[0];
      }
    }
    return yield wr(t);
  });
}
function wr(n) {
  return E(this, null, function* () {
    const e = yield new Blob(n).arrayBuffer();
    return new Uint8Array(e);
  });
}
class xr extends Error {
  constructor({ resource: e, api: t, args: s, cause: r }) {
    if (super(`API Error on resource "${e}" at api "${t}"`), this.causeProperties = {}, this.name = "API Error", this.resource = e, this.api = t, this.cause = r, this.args = s, r instanceof Error)
      for (const [i, o] of Object.entries(r))
        if (typeof Headers != "undefined" && o instanceof Headers) {
          const c = {};
          o.forEach((d, f) => {
            c[f] = d;
          }), this.causeProperties[i] = c;
        } else
          this.causeProperties[i] = o;
    const a = this.causeProperties.body;
    a && typeof a == "object" && "code" in a && (this.code = a.code);
  }
}
class Wt extends Error {
  constructor({
    url: e,
    method: t,
    statusCode: s,
    requestHeaders: r,
    responseHeaders: a,
    body: i
  }) {
    if (super("Fetch Error"), this.name = "Fetch Error", this.url = e, this.method = t, this.statusNumber = s, this.requestHeaders = r, this.responseHeaders = a, i)
      try {
        const o = JSON.parse(i);
        this.body = o;
      } catch (o) {
        this.body = i;
      }
  }
}
class Ne extends Error {
  constructor(e = {}) {
    const { canceled: t = !1 } = e;
    super("Abort Error"), this.name = "Abort Error", this.canceled = t;
  }
}
class kr extends Error {
  constructor(e) {
    super(`Async API Error: ${JSON.stringify(e)}`), this.name = "Async API Error", this.body = e;
  }
}
class ft extends Error {
  constructor(e) {
    super(e), this.name = "Request Validation Error";
  }
}
function un() {
  return Array.from(
    { length: 32 },
    () => Math.floor(Math.random() * 256).toString(16).padStart(2, "0")
  ).join("");
}
function kt() {
  return Math.floor(Date.now() / 1e3).toString();
}
const Tr = 5 * 60 * 1e3, Sr = 1 * 1e3;
var pe, F, G, Tt, St, je;
class Er {
  constructor({ fetch: e = globalThis.fetch.bind(globalThis), baseAddress: t }) {
    z(this, G), z(this, pe), z(this, F), this.baseAddress = t, j(this, pe, e), j(this, F, {}), this.plugins = [];
  }
  get headers() {
    throw new Error("Missing implementation");
  }
  addPlugin(e) {
    this.plugins.push(e);
  }
  removePlugin(e) {
    this.plugins = this.plugins.filter((t) => t.name !== e);
  }
  withOptions(e = {}) {
    return j(this, F, e), this;
  }
  get(e) {
    return E(this, arguments, function* (t, s = {}) {
      const { overrideBaseAddress: r, overrideDefaultHeaders: a } = s, i = r != null ? r : this.baseAddress;
      let o = a != null ? a : this.headers;
      const c = Oe(T(this, F));
      return j(this, F, {}), c.extraHeaders && (o = V(V({}, o), c.extraHeaders)), c.requestValidation && (o = Ot(V({}, o), { "X-Request-Nonce": un(), "X-Request-Timestamp": kt() })), c.async ? yield X(this, G, St).call(this, `${i}${t}`, c.async, { headers: o }) : yield X(this, G, Tt).call(this, `${i}${t}`, c, { headers: o });
    });
  }
  post(e, t) {
    return E(this, arguments, function* (s, r, a = {}) {
      const i = Oe(T(this, F));
      return j(this, F, {}), X(this, G, je).call(this, s, "POST", r, a, i);
    });
  }
  put(e, t) {
    return E(this, arguments, function* (s, r, a = {}) {
      const i = Oe(T(this, F));
      return j(this, F, {}), X(this, G, je).call(this, s, "PUT", r, a, i);
    });
  }
  delete(e, t) {
    return E(this, arguments, function* (s, r, a = {}) {
      const i = Oe(T(this, F));
      return j(this, F, {}), X(this, G, je).call(this, s, "DELETE", r, a, i);
    });
  }
  patch(e, t) {
    return E(this, arguments, function* (s, r, a = {}) {
      const i = Oe(T(this, F));
      return j(this, F, {}), X(this, G, je).call(this, s, "PATCH", r, a, i);
    });
  }
}
pe = /* @__PURE__ */ new WeakMap(), F = /* @__PURE__ */ new WeakMap(), G = /* @__PURE__ */ new WeakSet(), Tt = function(n, e, t) {
  return E(this, null, function* () {
    const s = () => E(this, null, function* () {
      var c, d;
      try {
        return yield T(this, pe).call(this, n, V(V({}, t), e.abortSignal && { signal: e.abortSignal }));
      } catch (f) {
        throw f instanceof Error && f.name === "AbortError" ? new Ne({ canceled: (d = (c = e.abortSignal) == null ? void 0 : c.aborted) != null ? d : !1 }) : f;
      }
    }), { headers: r } = t != null ? t : {}, a = (c, d) => {
      var f, _;
      return ((f = c == null ? void 0 : c.headers) == null ? void 0 : f.get(d)) || ((_ = c == null ? void 0 : c.headersObject) == null ? void 0 : _[d]) || "";
    }, i = (c) => E(this, null, function* () {
      var d;
      if (!c.ok) {
        const _ = yield c.text().catch();
        throw new Wt({
          url: n,
          method: (d = t == null ? void 0 : t.method) != null ? d : "GET",
          statusCode: c.status,
          requestHeaders: r,
          responseHeaders: c.headers,
          body: _
        });
      }
      if (e.requestValidation && process.env.UI_TESTS !== !0)
        try {
          const _ = a(c, "x-response-nonce"), I = r == null ? void 0 : r["X-Request-Nonce"];
          if (!_ || _ !== I)
            throw new ft("Response nonce mismatch");
          const A = Number(a(c, "x-response-timestamp")), O = Number(kt()), Z = 60 * 60 * 24;
          if (isNaN(A) || Math.abs(O - A) > Z)
            throw new ft("Invalid response timestamp");
        } catch (_) {
          const I = _ instanceof Error ? _.message : "Request validation failed";
          throw new ft(I);
        }
      let f = yield c.text();
      try {
        f = JSON.parse(f);
      } catch (_) {
      }
      return f;
    });
    if (e.retry) {
      const c = yield new vr({
        maxAttempts: e.retry,
        func: s
      }).run();
      return yield i(c);
    }
    const o = yield s();
    return yield i(o);
  });
}, St = function(n, e, t) {
  return E(this, null, function* () {
    var s, r;
    const {
      onProgress: a,
      abortSignal: i,
      pollingInterval: o = () => Sr,
      maxTimeout: c = Tr
    } = e, d = `${n}/async`, f = `${n}/async/job`;
    let _;
    try {
      _ = yield T(this, pe).call(this, d, V(V({}, t), i && { signal: i }));
    } catch (O) {
      throw O instanceof Error && O.name === "AbortError" ? new Ne({ canceled: (s = i == null ? void 0 : i.aborted) != null ? s : !1 }) : O;
    }
    if (!_.ok) {
      const O = yield _.text().catch();
      throw new Wt({
        url: n,
        method: (r = t == null ? void 0 : t.method) != null ? r : "GET",
        statusCode: _.status,
        requestHeaders: this.headers,
        responseHeaders: _.headers,
        body: O
      });
    }
    const I = yield _.json(), { job_id: A } = I;
    if (!A)
      throw new Error("Job ID not found in response");
    return new Promise((O, Z) => E(this, null, function* () {
      const W = setTimeout(() => {
        Z(new Error("Job timed out"));
      }, c), te = (oe = 0) => E(this, null, function* () {
        if (i != null && i.aborted) {
          clearTimeout(W), T(this, pe).call(this, `${f}/${A}/cancel`, { method: "POST", headers: this.headers }).then(() => {
            Z(new Ne({ canceled: !0 }));
          }).catch((N) => {
            Z(new Ne({ canceled: !1 }));
          });
          return;
        }
        try {
          const N = yield (yield T(this, pe).call(this, `${f}/${A}`, { headers: this.headers })).json();
          if (N.status === "success") {
            clearTimeout(W);
            const ne = N.response_json;
            O(ne);
          } else if (N.status === "failed")
            clearTimeout(W), Z(new kr(N.response_json));
          else {
            a && a(N.response_json);
            const ne = o(oe);
            setTimeout(() => te(oe + 1), ne);
          }
        } catch (N) {
          Z(N);
        }
      });
      te();
    }));
  });
}, je = function(n, e, t, s, r) {
  return E(this, null, function* () {
    const { overrideBaseAddress: a, overrideDefaultHeaders: i } = s, o = a != null ? a : this.baseAddress;
    let c = i != null ? i : this.headers;
    r.extraHeaders && (c = V(V({}, c), r.extraHeaders)), r.requestValidation && (c = Ot(V({}, c), { "X-Request-Nonce": un(), "X-Request-Timestamp": kt() }));
    let d = s.skipBodyJsonStringify ? t : JSON.stringify(t);
    return r.compress && _r() && (c["Content-Encoding"] = "gzip", d = yield br(d)), r.async ? yield X(this, G, St).call(this, `${o}${n}`, r.async, {
      method: e,
      headers: c,
      body: d
    }) : yield X(this, G, Tt).call(this, `${o}${n}`, r, { method: e, headers: c, body: d });
  });
};
const Bt = (n, e, t, s) => n instanceof Ne ? n : new xr({ resource: e, api: String(t), args: s, cause: n }), ht = (n, e) => new Proxy(e, {
  get(t, s) {
    return (...r) => {
      var a;
      for (const o of n.plugins) {
        const c = (a = o.beforeApi) == null ? void 0 : a.call(o, { resource: t.resourceName, api: s, args: r });
        if (c !== void 0)
          return c;
      }
      let i;
      try {
        i = t[s](...r);
      } catch (o) {
        throw Bt(o, t.resourceName, s, r);
      }
      return i instanceof Promise ? i.catch((o) => {
        throw Bt(o, t.resourceName, s, r);
      }) : i;
    };
  }
});
var Re;
class Ar {
  constructor(e) {
    z(this, Re), this.resourceName = "Files", j(this, Re, e);
  }
  get(e) {
    return E(this, arguments, function* ({ fileKey: t, params: s = {} }) {
      const r = new URLSearchParams(V({
        plugin_data: "857346721138427857"
      }, s)).toString(), a = `v1/files/${t}?${r}`;
      return yield T(this, Re).get(a);
    });
  }
  getImageFills(e) {
    return E(this, arguments, function* ({ fileKey: t }) {
      var s, r;
      const a = `v1/files/${t}/images`;
      return (r = (s = (yield T(this, Re).get(a)).meta) == null ? void 0 : s.images) != null ? r : {};
    });
  }
}
Re = /* @__PURE__ */ new WeakMap();
const Or = (n, e, t) => {
  const s = e.sort();
  return `${n}-${s.join("-")}-${t}`;
}, Cr = (n) => n ? n.ts > Date.now() - 1e3 * 30 : !1;
var K, Et, dn;
class Ir {
  constructor(e) {
    z(this, Et), z(this, K), this.resourceName = "Images", j(this, K, e);
  }
  /**
   * Return the URL for the _layer_ images for the given nodes.
   * Note: Use the `file.images` API to get the _source_ images used on the node fills, which has better quality.
   */
  get(e) {
    return E(this, arguments, function* ({ fileKey: t, nodeIds: s, format: r = "jpg", scale: a }) {
      const i = Or(t, s, r), o = T(this, K).cache.images.entries.get(i);
      if (Cr(o))
        return o.result;
      o && T(this, K).cache.images.entries.delete(i);
      const c = T(this, K).cache.images.pendingRequests.get(i);
      if (c)
        return c;
      const d = X(this, Et, dn).call(this, i, t, s, r, a);
      T(this, K).cache.images.pendingRequests.set(i, d);
      try {
        return yield d;
      } finally {
        T(this, K).cache.images.pendingRequests.delete(i);
      }
    });
  }
}
K = /* @__PURE__ */ new WeakMap(), Et = /* @__PURE__ */ new WeakSet(), dn = function(n, e, t, s, r) {
  return E(this, null, function* () {
    const a = yield T(this, K).get(
      `v1/images/${e}?ids=${t}&format=${s}${r ? `&scale=${r}` : ""}`
    );
    return T(this, K).cache.images.entries.set(n, {
      result: a,
      ts: Date.now()
    }), a;
  });
};
var Ye;
class Nr {
  constructor(e) {
    z(this, Ye), this.resourceName = "Nodes", j(this, Ye, e);
  }
  get(e) {
    return E(this, arguments, function* ({ fileKey: t, nodeIds: s, params: r = {} }) {
      const a = Ot(V({}, r), {
        ids: s.join(",")
      }), i = new URLSearchParams(V({
        plugin_data: "857346721138427857"
      }, a)).toString(), o = `v1/files/${t}/nodes?${i}`;
      return yield T(this, Ye).get(o);
    });
  }
}
Ye = /* @__PURE__ */ new WeakMap();
var ce;
class ln extends Er {
  constructor({
    baseAddress: e = "https://api.figma.com/",
    fetch: t = globalThis.fetch.bind(globalThis)
  } = {}) {
    super({ fetch: t, baseAddress: e }), z(this, ce, ""), this.cache = {
      images: {
        entries: /* @__PURE__ */ new Map(),
        pendingRequests: /* @__PURE__ */ new Map()
      }
    }, this.files = ht(this, new Ar(this)), this.nodes = ht(this, new Nr(this)), this.images = ht(this, new Ir(this));
  }
  set token(e) {
    if (!e.startsWith("figd_") && !e.startsWith("figu_"))
      throw new Error("Invalid Figma access token");
    j(this, ce, e);
  }
  get token() {
    return T(this, ce);
  }
  get headers() {
    const e = {
      "Content-Type": "application/json"
    };
    return T(this, ce).startsWith("figd_") ? e["X-FIGMA-TOKEN"] = T(this, ce) : T(this, ce).startsWith("figu_") && (e.Authorization = `Bearer ${T(this, ce)}`), e;
  }
}
ce = /* @__PURE__ */ new WeakMap();
const Vr = (r) => P(void 0, [r], function* ({
  fileKey: n,
  authToken: e,
  figmaRestApi: t = new ln(),
  params: s = {}
}) {
  e && (t.token = e);
  try {
    return yield t.files.get({
      fileKey: n,
      params: s
    });
  } catch (a) {
    throw console.error(a), a;
  }
}), Ur = (a) => P(void 0, [a], function* ({
  fileKey: n,
  authToken: e,
  nodeIds: t,
  figmaRestApi: s = new ln(),
  params: r = {}
}) {
  e && (s.token = e);
  try {
    return (yield s.nodes.get({
      fileKey: n,
      nodeIds: t,
      params: u({}, r)
    })).nodes;
  } catch (i) {
    return Ps(i, n);
  }
}), jr = (n, e) => new ReadableStream({
  start(t) {
    n.generateCode(e, (s) => {
      s.type === "error" ? (console.log("NOT SURE IF THIS IS REACHABLE, ALL ERRORS ARE THROWING"), t.enqueue({
        type: "error",
        payload: { message: s.payload.reason }
      })) : t.enqueue(s), (s.type === "aborted" || s.type === "error") && t.close();
    }).then((s) => {
      t.enqueue({
        type: "done",
        payload: {
          tokenUsage: s.tokenUsage,
          sessionId: s.sessionId
        }
      }), t.close();
    }).catch((s) => {
      t.enqueue({
        type: "error",
        payload: {
          message: "message" in s ? s.message : "Unknown",
          status: "status" in s ? s.status : void 0
        }
      }), t.close();
    });
  }
}), zr = (n, e) => P(void 0, null, function* () {
  var c, d, f, _, I, A, O;
  const t = jr(n, e), [s, r] = t.tee(), a = yield s.getReader().read();
  if (a.done || !a.value || ((c = a.value) == null ? void 0 : c.type) === "error" && ((f = (d = a.value) == null ? void 0 : d.payload) != null && f.status))
    return new Response(JSON.stringify(a.value), {
      status: ((_ = a.value) == null ? void 0 : _.type) === "error" && (O = (A = (I = a.value) == null ? void 0 : I.payload) == null ? void 0 : A.status) != null ? O : 500,
      headers: {
        "Content-Type": "application/json"
      }
    });
  const i = new TextEncoder(), o = r.pipeThrough(
    new TransformStream({
      transform(Z, W) {
        const te = `event: ${Z.type}
data: ${JSON.stringify(
          Z
        )}

`;
        W.enqueue(i.encode(te));
      }
    })
  );
  return new Response(o, {
    status: 200,
    headers: {
      "Content-Type": "text/event-stream; charset=utf-8",
      Connection: "keep-alive",
      "Cache-Control": "no-cache"
    }
  });
});
export {
  Zr as Anima,
  Ae as CodegenError,
  Is as FigmaTokenIssue,
  js as NotFound,
  Ns as RateLimitExceeded,
  Pr as ResponseError,
  Zs as UnknownFigmaApiException,
  zr as createCodegenResponseEventStream,
  jr as createCodegenStream,
  $r as formatToFigmaLink,
  Dr as getFigmaApiErrorType,
  Vr as getFigmaFile,
  Ur as getFileNodes,
  Fr as getRelatedScreenFiles,
  Ps as handleFigmaApiError,
  $s as isFigmaTokenIssue,
  Rs as isNotFound,
  Ms as isRateLimitExceeded,
  Lr as isUnknownFigmaApiException,
  Mr as isValidFigmaUrl,
  Es as validateSettings
};
//# sourceMappingURL=index.js.map
